{
  "nav": {
    "dashboard": "Übersicht",
    "chats": "Konversationen",
    "archive": "Archiv",
    "settings": "Einstellungen",
    "studioData": "Studio-Daten",
    "propertyData": "Objektdaten",
    "expandMenu": "Menü ausklappen",
    "collapseMenu": "Menü einklappen",
    "goToDashboard": "Zur Übersicht",
    "logOut": "Abmelden"
  },
  "layout": {
    "lastUpdatedJustNow": "Zuletzt soeben aktualisiert",
    "lastUpdatedOneMin": "Zuletzt vor 1 Min. aktualisiert",
    "lastUpdatedMins": "Zuletzt vor {{count}} Min. aktualisiert",
    "wsOffline": "Verbindung unterbrochen. Aktualisieren oder auf Wiederherstellung warten.",
    "refresh": "Aktualisieren",
    "refreshing": "Wird aktualisiert…"
  },
  "settings": {
    "title": "Einstellungen",
    "subtitle": "Konto, Team und Kanäle verwalten.",
    "tabAccount": "Konto",
    "tabTeam": "Teamverwaltung",
    "tabChannels": "Kanäle",
    "tabAi": "KI-Verhalten",
    "logOut": "Abmelden",
    "noPermissionToast": "Sie haben keine Berechtigung, diesen Bereich anzuzeigen.",
    "connections": {
      "email": {
        "channelLabel": "E-Mail",
        "appliesToAllStudios": "Alle Studios",
        "addressLabel": "Postfach",
        "defaultStudioLabel": "Standardstudio für neue Threads",
        "statusConnected": "Verbunden",
        "statusReconnectRequired": "Erneute Verbindung erforderlich",
        "statusDisconnected": "Nicht verbunden",
        "statusError": "Fehler",
        "statusSkipped": "Übersprungen",
        "connect": "Verbinden",
        "reconnect": "Erneut verbinden",
        "disconnect": "Trennen",
        "reconnectBanner": "Ihre E-Mail-Verbindung ist abgelaufen. Verbinden Sie erneut, um Nachrichten zu senden und zu empfangen.",
        "reconnectBannerCta": "E-Mail erneut verbinden",
        "disconnectTitle": "E-Mail trennen?",
        "disconnectBody": "Der Zugriff auf Ihr gemeinsames Postfach wird widerrufen. Vergangene Threads bleiben lesbar; Senden ist deaktiviert, bis Sie erneut verbinden.",
        "toastDisconnected": "E-Mail getrennt.",
        "toastDisconnectFailed": "E-Mail konnte nicht getrennt werden."
      }
    }
  },
  "account": {
    "displayLanguageTitle": "Anzeigesprache",
    "displayLanguageHint": "Englisch, Deutsch, Französisch, Italienisch und Spanisch gelten in der gesamten App, einschließlich Anmeldung, Registrierung und Onboarding.",
    "displayLanguageLabel": "Sprache",
    "languageUpdated": "Anzeigesprache aktualisiert.",
    "emailTitle": "E-Mail-Adresse",
    "newEmail": "Neue E-Mail",
    "currentPassword": "Aktuelles Passwort",
    "emailPasswordPlaceholder": "Erforderlich zur E-Mail-Änderung",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "changeEmail": "E-Mail ändern",
    "passwordTitle": "Passwort",
    "passwordSharedWarning": "Dieses Passwort gilt sowohl für die OktoGo-Studio-App als auch für das Management-Portal. Wenn Sie es hier ändern, ändert sich Ihre Anmeldung für beide.",
    "passwordConfirmTitle": "Passwort auf beiden Plattformen ändern?",
    "passwordConfirmBody": "Dadurch ändert sich Ihre Anmeldung sowohl für die OktoGo-Studio-App (app.oktogo.ai) als auch für Management mit derselben E-Mail-Adresse.",
    "passwordConfirmCancel": "Abbrechen",
    "passwordConfirmSubmit": "Ja, Passwort ändern",
    "newPassword": "Neues Passwort",
    "confirmNewPassword": "Neues Passwort bestätigen",
    "updatePassword": "Passwort aktualisieren",
    "changePassword": "Passwort ändern",
    "verticalLabel": "Branche",
    "notificationTitle": "Benachrichtigungen",
    "escalationAlerts": "Eskalationshinweise",
    "escalationAlertsDesc": "Push, wenn ein Chat zur Prüfung oder Übernahme eskaliert (immer aktiv). Die Eskalations-E-Mail mit Grund und Chat-Auszug ist getrennt von WhatsApp-Sitzungsablauf-Mails. Eine Account-Option zum Stummschalten nur der Eskalations-E-Mail kommt bald; Push bleibt aktiv.",
    "weeklySummary": "Wöchentliche Zusammenfassung",
    "weeklySummaryDesc": "Wöchentlichen Leistungsbericht erhalten",
    "connectionWarnings": "Verbindungswarnungen",
    "connectionWarningsDesc": "Hinweis, wenn eine Plattformverbindung abbricht",
    "notificationsSaved": "Benachrichtigungseinstellungen gespeichert.",
    "verticalFitness": "Fitness / Studio",
    "verticalStr": "Kurzzeitmiete",
    "toastCurrentPasswordForEmail": "Bitte aktuelles Passwort eingeben, um die E-Mail zu ändern.",
    "toastVerificationEmailSent": "Bestätigungs-E-Mail an neue Adresse gesendet.",
    "toastEmailUpdateFailed": "E-Mail konnte nicht aktualisiert werden.",
    "toastPasswordMismatch": "Passwörter stimmen nicht überein.",
    "toastPasswordUpdated": "Passwort erfolgreich aktualisiert.",
    "toastPasswordUpdateFailed": "Passwort konnte nicht aktualisiert werden.",
    "toastVerticalUpdated": "Branche aktualisiert.",
    "toastVerticalUpdateFailed": "Branche konnte nicht aktualisiert werden.",
    "toastPreferencesSaveFailed": "Speichern fehlgeschlagen.",
    "studioNameTitleStudio": "Studio-Name",
    "studioNameTitleProperty": "Objektname",
    "studioNameHint": "So erscheint Ihr Standort in der App, Benachrichtigungen und kundenorientierten Nachrichten.",
    "studioNameContextHint": "Wählen Sie ein einzelnes Studio aus, um den Namen zu bearbeiten.",
    "studioNameValidation": "Der Name muss zwischen 2 und 60 Zeichen lang sein.",
    "toastStudioNameUpdated": "Studio-Name aktualisiert.",
    "toastPropertyNameUpdated": "Objektname aktualisiert.",
    "toastStudioNameUpdateFailed": "Name konnte nicht aktualisiert werden."
  },
  "auth": {
    "languageSwitcherAria": "Anzeigesprache",
    "placeholderEmailExample": "sie@studio.com",
    "placeholderPassword": "••••••••",
    "placeholderPasswordCreate": "Passwort festlegen",
    "placeholderPasswordConfirm": "Passwort wiederholen",
    "placeholderStudioName": "Ihr Studio-Name",
    "onboardingSelectPlatform": "Plattform wählen",
    "onboarding2faSecret": "2FA-Geheimnis oder Backup-Code eingeben",
    "login": {
      "subtitle": "Melden Sie sich bei Ihrem Studio an",
      "lockout": "Zu viele fehlgeschlagene Versuche. Versuchen Sie es in {{minutes}} Minuten erneut.",
      "emailLabel": "E-Mail-Adresse",
      "passwordLabel": "Passwort",
      "passwordPlaceholder": "Passwort eingeben",
      "rememberMe": "Angemeldet bleiben",
      "rememberMeHelpOn": "Auf diesem Gerät angemeldet bleiben, auch nachdem der Browser geschlossen wurde.",
      "rememberMeHelpOff": "Sie werden abgemeldet, sobald der Browser geschlossen wird.",
      "logIn": "Anmelden",
      "forgotPassword": "Passwort vergessen?",
      "orDivider": "oder",
      "continueWithGoogle": "Mit Google fortfahren",
      "noAccount": "Noch kein Konto?",
      "createAccount": "Konto erstellen →",
      "sessionExpiredToast": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
      "pilotInviteHandoff": "Ihre Pilot-Einladung wurde angenommen. Melden Sie sich mit dem Passwort an, das Sie gerade erstellt haben.",
      "errorIncorrectCredentials": "E-Mail oder Passwort falsch.",
      "errorEmailNotVerified": "E-Mail-Adresse ist nicht verifiziert.",
      "resendVerificationAction": "Bestätigungs-E-Mail erneut senden",
      "resendVerificationToast": "Bestätigungs-E-Mail gesendet. Prüfen Sie Ihren Posteingang.",
      "resendVerificationRateLimited": "Zu viele Versuche. Bitte warten Sie 15 Minuten, bevor Sie eine weitere Bestätigungsmail anfordern.",
      "goToVerificationPage": "Zur Bestätigungsseite →",
      "errorNetwork": "Server nicht erreichbar. Starten Sie die API (z. B. npm run dev oder dev:server) und versuchen Sie es erneut.",
      "errorGooglePopupBlocked": "Ein Pop-up wurde blockiert. Erlauben Sie Pop-ups für diese Website und versuchen Sie es erneut.",
      "errorGoogleSignIn": "Google-Anmeldung fehlgeschlagen. Versuchen Sie es erneut oder nutzen Sie E-Mail und Passwort."
    },
    "register": {
      "subtitle": "Konto erstellen",
      "studioNameLabel": "Studio-Name",
      "emailLabel": "E-Mail-Adresse",
      "passwordLabel": "Passwort",
      "createAccount": "Konto erstellen",
      "orDivider": "oder",
      "continueWithGoogle": "Mit Google fortfahren",
      "hasAccount": "Bereits ein Konto?",
      "logIn": "Anmelden →",
      "validationStudioName": "Der Studio-Name muss mindestens 2 Zeichen haben.",
      "validationEmail": "Geben Sie eine gültige E-Mail-Adresse ein.",
      "validationPassword": "Das Passwort muss mindestens 8 Zeichen haben und 1 Buchstabe sowie 1 Zahl enthalten.",
      "registrationFailed": "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "duplicateEmailLead": "Ein Konto mit dieser E-Mail existiert bereits.",
      "duplicateEmailLink": "Anmelden →"
    },
    "forgot": {
      "subtitle": "Passwort zurücksetzen",
      "emailLabel": "E-Mail-Adresse",
      "sentLead": "Prüfen Sie Ihren Posteingang. Wir haben einen Link zum Zurücksetzen an Ihre E-Mail gesendet.",
      "backToLogin": "← Zurück zur Anmeldung",
      "testResetLink": "(Test: zur Passwort-zurücksetzen-Seite)",
      "sendResetLink": "Link zum Zurücksetzen senden",
      "errorGeneric": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      "networkError": "Netzwerkfehler. Bitte versuchen Sie es erneut."
    },
    "reset": {
      "invalidLink": "Dieser Link zum Zurücksetzen ist ungültig oder abgelaufen.",
      "requestNewLink": "Neuen Link anfordern →",
      "tokenUsed": "Dieser Link wurde bereits verwendet.",
      "requestNewOne": "Neuen Link anfordern →",
      "successBody": "Passwort aktualisiert. Bitte melden Sie sich an.",
      "goToLogin": "Zur Anmeldung →",
      "subtitle": "Neues Passwort festlegen",
      "newPasswordLabel": "Neues Passwort",
      "confirmPasswordLabel": "Passwort bestätigen",
      "resetButton": "Passwort zurücksetzen",
      "testSimulateUsed": "(Test: bereits verwendeten Token simulieren)",
      "errorPasswordRules": "Das Passwort muss mindestens 8 Zeichen haben und 1 Buchstabe sowie 1 Zahl enthalten.",
      "errorPasswordMismatch": "Die Passwörter stimmen nicht überein.",
      "errorTokenExpired": "Dieser Link ist abgelaufen. Fordern Sie einen neuen an.",
      "networkError": "Netzwerkfehler. Bitte versuchen Sie es erneut.",
      "errorGeneric": "Etwas ist schiefgelaufen."
    },
    "invite": {
      "invalidToken": "Dieser Einladungslink ist ungültig.",
      "goToLogin": "Zur Anmeldung →",
      "subtitle": "Teameinladung annehmen",
      "invalidUsed": "Diese Einladung ist ungültig oder bereits verwendet.",
      "expired": "Diese Einladung ist abgelaufen.",
      "expiredHint": "Bitten Sie Ihren Studio-Administrator, die Einladung erneut zu senden.",
      "successRedirect": "Einladung angenommen. Weiterleitung zum Dashboard …",
      "createPasswordLabel": "Passwort erstellen",
      "termsPrivacy": "Ich akzeptiere die Nutzungsbedingungen und die Datenschutzerklärung.",
      "acceptButton": "Einladung annehmen",
      "validationPassword": "Das Passwort muss mindestens 8 Zeichen haben und 1 Buchstabe sowie 1 Zahl enthalten.",
      "validationTerms": "Sie müssen die Bedingungen akzeptieren.",
      "errorAcceptFailed": "Einladung konnte nicht angenommen werden.",
      "errorNoSession": "Einladung angenommen, aber keine Anmeldesitzung erstellt.",
      "networkError": "Netzwerkfehler. Bitte versuchen Sie es erneut."
    },
    "civ": {
      "documentTitle": "E-Mail bestätigen — OktoGo",
      "headerSubtitle": "Mit der Bestätigung Ihrer E-Mail-Adresse kann das Studio Ihre Buchung fortsetzen.",
      "consent": {
        "headline": "Bestätigen Sie sich für {{ studioName }}",
        "body": "Damit bestätigen Sie diese E-Mail-Adresse und erlauben {{ studioName }} (powered by OktoGo.ai), die von Ihnen auf {{ channelLabel }} gewünschte Buchungsaktion auszuführen.",
        "checkboxEmail": "Ich bestätige, dass diese E-Mail-Adresse mir gehört.",
        "checkboxData": "Ich stimme zu, dass OktoGo.ai meine personenbezogenen Daten speichert und verarbeitet, um diese Anfrage zu erfüllen, wie in der <a>Datenschutzerklärung</a> beschrieben.",
        "privacyPolicyAriaLabel": "Datenschutzerklärung von OktoGo.ai (wird in neuem Tab geöffnet)",
        "confirmButton": "Bestätigen & fortfahren",
        "confirmButtonSubmitting": "Bestätigung läuft…",
        "declineLink": "Das war ich nicht — ablehnen",
        "errorGeneric": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
        "errorRateLimited": "Zu viele Versuche. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
        "errorVersionMismatch": "Wir haben diese Seite aktualisiert. Bitte laden Sie sie neu und versuchen Sie es erneut."
      },
      "success": {
        "headline": "Sie sind verifiziert.",
        "body": "Sie können nun zu Ihrem {{ channelLabel }}-Chat mit {{ studioName }} zurückkehren, um fortzufahren. Wir machen genau dort weiter, wo Sie aufgehört haben.",
        "closeHint": "Sie können diesen Tab gefahrlos schließen."
      },
      "error": {
        "expiredHeadline": "Dieser Link ist abgelaufen",
        "expiredBody": "Aus Sicherheitsgründen ist der Link nur kurz gültig. Antworten Sie bitte in Ihrem Chat, dann senden wir Ihnen einen neuen Link.",
        "invalidHeadline": "Dieser Link ist ungültig",
        "invalidBody": "Der Link konnte nicht erkannt werden. Antworten Sie bitte in Ihrem Chat, um erneut zu starten.",
        "usedHeadline": "Bereits bestätigt",
        "usedBody": "Diese E-Mail-Adresse wurde bereits bestätigt. Sie können zu Ihrem Chat zurückkehren, um fortzufahren.",
        "networkHeadline": "Verbindungsproblem",
        "networkBody": "OktoGo konnte nicht erreicht werden. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
        "networkRetryButton": "Erneut versuchen"
      },
      "declined": {
        "headline": "Verstanden — wir machen nicht weiter.",
        "body": "Wir haben Ihre Ablehnung erfasst. Sollte das ein Versehen gewesen sein, kontaktieren Sie bitte unseren Support — wir helfen Ihnen gern."
      },
      "terminal": {
        "contactSupport": "Support kontaktieren",
        "contactSupportAriaLabel": "OktoGo-Support per E-Mail kontaktieren"
      }
    },
    "verify": {
      "title": "Posteingang prüfen",
      "bodyGeneric": "Wir haben einen Bestätigungslink an Ihre E-Mail-Adresse gesendet. Klicken Sie auf den Link, um Ihr Konto zu bestätigen.",
      "bodyWithEmail": "Wir haben eine Bestätigungsmail an {{email}} gesendet. Klicken Sie auf den Link, um Ihr Konto zu bestätigen.",
      "linkExpiredTitle": "Ihr Bestätigungslink ist abgelaufen.",
      "resendLink": "Bestätigungsmail erneut senden",
      "rateLimited": "Zu viele Versuche. Bitte warten Sie 15 Minuten, bevor Sie eine weitere Bestätigungsmail anfordern.",
      "resendButton": "Bestätigungsmail erneut senden",
      "resendButtonDone": "Bestätigungsmail erneut gesendet ✓",
      "footerHint": "Nicht erhalten? Prüfen Sie den Spam-Ordner oder fordern Sie einen neuen Link an.",
      "testExpired": "(Test: abgelaufenen Token simulieren)"
    },
    "verifyToken": {
      "loadingTitle": "E-Mail wird bestätigt",
      "loadingBody": "Bitte warten Sie, während wir Ihr Konto bestätigen.",
      "successTitle": "E-Mail bestätigt",
      "successBody": "Ihr Konto ist bestätigt. Sie können sich jetzt anmelden.",
      "invalidTitle": "Ungültiger Bestätigungslink",
      "invalidBody": "Dieser Link ist ungültig. Fordern Sie auf der Anmeldeseite eine neue Bestätigungs-E-Mail an.",
      "expiredTitle": "Bestätigungslink abgelaufen",
      "expiredBody": "Dieser Link ist abgelaufen. Fordern Sie auf der Anmeldeseite eine neue Bestätigungs-E-Mail an.",
      "errorTitle": "Bestätigung fehlgeschlagen",
      "errorBody": "Wir konnten Ihre E-Mail nicht bestätigen. Bitte versuchen Sie es erneut oder fordern Sie einen neuen Link an.",
      "goToLogin": "Zur Anmeldung"
    },
    "verifyEmailChange": {
      "loadingTitle": "Neue E-Mail wird bestätigt",
      "loadingBody": "Bitte warten Sie, während wir Ihre E-Mail-Änderung bestätigen.",
      "successTitle": "E-Mail erfolgreich aktualisiert",
      "successBody": "Ihre E-Mail-Adresse wurde aktualisiert.",
      "successBodyWithEmail": "Ihre neue Anmelde-E-Mail ist {{email}}.",
      "invalidTitle": "Ungültiger E-Mail-Änderungslink",
      "invalidBody": "Dieser Link zur E-Mail-Änderung ist ungültig oder wurde bereits verwendet.",
      "expiredTitle": "Link zur E-Mail-Änderung abgelaufen",
      "expiredBody": "Dieser Link zur E-Mail-Änderung ist abgelaufen. Starten Sie die Änderung erneut in den Einstellungen.",
      "errorTitle": "E-Mail-Änderung konnte nicht bestätigt werden",
      "errorBody": "Beim Bestätigen Ihrer E-Mail-Änderung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
      "goToLogin": "Zum Login →"
    }
  },
  "common": {
    "search": "Suchen…",
    "filter": "Filter",
    "sort": "Sortieren",
    "apply": "Anwenden",
    "applyWithCount": "Anwenden ({{count}})",
    "reset": "Zurücksetzen",
    "clearAll": "Alle löschen",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "loading": "Wird geladen…",
    "nameAZ": "Name A–Z",
    "nameZA": "Name Z–A",
    "moreFilters": "+{{count}} weitere",
    "moreFiltersAria": "{{count}} weitere aktive Filter — Liste öffnen",
    "additionalFilters": "Weitere Filter",
    "removeFilterAria": "Filter „{{label}}“ entfernen",
    "loadingRoute": "Seite wird geladen…",
    "loadingContent": "Inhalt wird geladen…",
    "loadingTable": "Tabelle wird geladen…"
  },
  "dashboard": {
    "todaysStats": "Heutige Kennzahlen",
    "needsAttention": "Benötigt Ihre Aufmerksamkeit",
    "seeAllChats": "Alle Konversationen",
    "badgeEscalated": "⚡ ESKALIERT",
    "badgeDraftReady": "✏ ENTWURF BEREIT",
    "allClear": "Alles erledigt! Derzeit keine aktiven Konversationen.",
    "weeklySummary": "Wochenübersicht",
    "conversationsByIntent": "Konversationen nach Absicht",
    "autoVsManual": "Automatisch vs. manuell",
    "legendAiHandled": "KI bearbeitet",
    "legendManual": "Manuell",
    "relativeJustNow": "Gerade eben",
    "relativeMinsAgo": "vor {{count}} Min.",
    "relativeOneHourAgo": "vor 1 Std.",
    "relativeHoursAgo": "vor {{count}} Std.",
    "relativeOneDayAgo": "vor 1 Tag",
    "relativeDaysAgo": "vor {{count}} Tagen",
    "intentApi": {
      "booking": "Buchung",
      "rebooking": "Umbuchung",
      "cancellation": "Stornierung",
      "info": "Info",
      "schedule": "Termin",
      "account": "Konto",
      "other": "Sonstiges"
    },
    "badgeSessionExpiring": "⏱ SESSION",
    "sessionExpiringTileWindow": "Freiform-Fenster endet {{time}}",
    "sessionBannerTitle": "WhatsApp-Antworten sind bald eingeschränkt",
    "sessionBannerBody": "Mindestens ein eskalierter Chat nähert sich dem Ende des Freiform-Nachrichtenfensters. Öffnen Sie Chats, um rechtzeitig zu antworten.",
    "sessionBannerDismiss": "Ausblenden",
    "sessionBannerOpenChats": "Gefilterte Chats öffnen",
    "relativeUntilShort": "noch {{time}}"
  },
  "team": {
    "selectStudioHint": "Wählen Sie oben ein Studio, um die Teamliste zu sehen, Mitglieder zu entfernen und „Erneut einladen“ für ausstehende Einladungen zu nutzen.",
    "aggregateListHint": "Teammitglieder und ausstehende Einladungen werden für alle Studios angezeigt, auf die Sie Zugriff haben. Entfernen und erneut senden beziehen sich auf das Studio in der jeweiligen Zeile.",
    "inviteMember": "Teammitglied einladen",
    "studiosMultiLabel": "Studios (eins oder mehrere wählen)",
    "studioSingleLabel": "Studio",
    "noStudiosForInvite": "Für Ihr Konto sind keine Studios für Einladungen verfügbar.",
    "includeStudioAria": "{{name}} einschließen",
    "emailAddress": "E-Mail-Adresse",
    "inviteNamePlaceholder": "Name eingeben",
    "emailPlaceholder": "team@studio.com",
    "role": "Rolle",
    "roleManager": "Manager",
    "roleStaff": "Mitarbeiter",
    "roleOwner": "Inhaber",
    "managerInviteHint": "Manager können nur Mitarbeiter einladen (je nach Studiozugriff).",
    "accessPreview": "Sie erhalten Zugang zu {{studios}} als {{role}}.",
    "sendInvitation": "Einladung senden",
    "colName": "Name",
    "pendingInviteNoName": "—",
    "pendingInviteNameSr": "Ausstehende Einladung für {{email}}",
    "emailInvalid": "Geben Sie eine gültige E-Mail-Adresse ein.",
    "colStudio": "Studio",
    "colEmail": "E-Mail",
    "colRole": "Rolle",
    "colStatus": "Status",
    "colActions": "Aktionen",
    "statusActive": "Aktiv",
    "statusPending": "Ausstehend",
    "ownerCannotRemove": "Studioinhaber können hier nicht entfernt werden",
    "inviteAgain": "Erneut einladen",
    "inviteToOtherStudios": "Zu anderen Studios einladen",
    "editAccess": "Zugriff bearbeiten",
    "editAccessLoadingStudios": "Studios werden geladen, in denen dieses Mitglied Zugriff hat…",
    "editAccessPerStudioHint": "Wählen Sie für jedes Studio eine Rolle. Es werden nur Studios angezeigt, die Sie verwalten können.",
    "editAccessNothingChanged": "Keine Änderungen zum Speichern.",
    "editAccessStudioRoleAria": "{{studio}} — Rolle",
    "editAccessMemberDetail": "{{name}} · {{email}}",
    "removeMemberMultiHint": "Wählen Sie alle Studios, aus denen diese Person entfernt werden soll. Nicht ausgewählte Studios behalten die Mitgliedschaft.",
    "removeMemberLoadingScope": "Studios werden geprüft…",
    "removeMemberStudioToggleAria": "Aus {{name}} entfernen",
    "removeMemberPickOneStudio": "Bitte mindestens ein Studio auswählen.",
    "toastMemberRemovedMulti": "Aus {{count}} Studios entfernt.",
    "toastRemovePartialFail": "Konnte nicht entfernen von: {{studios}}. Bitte für diese Studios erneut versuchen.",
    "resendInvitation": "Einladung erneut senden",
    "editPendingInviteAria": "Ausstehende Einladung für {{email}} bearbeiten",
    "editPendingInviteTitle": "Ausstehende Einladung bearbeiten",
    "editPendingInviteSave": "Änderungen speichern",
    "toastInviteUpdated": "Einladung aktualisiert.",
    "toastAccessUpdated": "Mitgliederzugriff aktualisiert.",
    "toastEditAccessPartialFail": "Zugriff konnte nicht aktualisiert werden für: {{studios}}. Bitte für diese Studios erneut versuchen.",
    "toastInviteUpdatePartial": "Alte Einladung wurde widerrufen, aber das erneute Senden ist fehlgeschlagen. Bitte über „Mitglied hinzufügen“ erneut einladen.",
    "removeMemberAria": "{{name}} aus Studio entfernen",
    "revokeInviteAria": "Einladung widerrufen",
    "removeMemberTitle": "Teammitglied entfernen",
    "removeMemberBody": "Diese Person wirklich aus dem Studio entfernen?",
    "removeMemberDetail": "{{name}} ({{email}}) verliert sofort den Zugriff auf dieses Studio.",
    "removeMemberDetailStudio": "{{name}} ({{email}}) verliert sofort den Zugriff auf {{studio}}.",
    "dangerIrreversible": "Dieser Schritt kann hier nicht rückgängig gemacht werden. Das OktoGo-Konto bleibt bestehen; Sie können die Person später erneut einladen.",
    "removeAnyway": "Trotzdem entfernen",
    "revokeTitle": "Einladung widerrufen",
    "revokeBody": "Die ausstehende Einladung an {{email}} wird storniert. Der aktuelle Link funktioniert nicht mehr.",
    "revokeHint": "Sie können später unter „Teammitglied einladen“ eine neue Einladung senden.",
    "revoke": "Widerrufen",
    "toastInviteSent": "Einladung gesendet.",
    "toastInviteFailed": "Einladung konnte nicht gesendet werden.",
    "toastAlreadyMember": "{{email}} ist bereits Mitglied dieses Studios. Öffne die Teamliste unten, um die Rolle zu verwalten.",
    "toastAlreadyMemberMulti": "{{email}} ist bereits Mitglied eines der ausgewählten Studios. Entferne den Haken und versuche es erneut.",
    "addMemberSearchPlaceholder": "Per Name oder E-Mail hinzufügen",
    "addMemberSearchHint": "Wähle eine Person aus deinen Studios oder gib eine neue E-Mail ein, um sie einzuladen.",
    "candidateSearching": "Wird gesucht…",
    "candidateNoMatches": "Keine passenden Teammitglieder in deinen Studios.",
    "candidateNoMatchHelp": "Wir kennen diese E-Mail noch nicht — wir senden eine Einladung.",
    "candidateAlreadyMemberBadge": "Bereits Mitglied",
    "candidateChange": "Ändern",
    "candidateAlreadyInLabel": "Bereits in: {{studios}}",
    "refineSearch": "Suche verfeinern.",
    "candidateAlreadyMemberHere": "{{name}} ist bereits Mitglied dieses Studios.",
    "grantAccessTitle": "Zugriff gewähren",
    "grantAccessButton": "Zugriff gewähren",
    "grantAccessNotice": "{{name}} sieht diesen Zugriff beim nächsten Öffnen von OktoGo.",
    "toastGrantSuccess": "Zugriff an {{name}} gewährt.",
    "toastGrantFailed": "Zugriff konnte nicht gewährt werden.",
    "toastMemberRemoved": "Mitglied aus diesem Studio entfernt.",
    "toastRemoveFailed": "Entfernen fehlgeschlagen.",
    "toastResent": "Einladung erneut gesendet.",
    "toastResendFailed": "Erneutes Senden fehlgeschlagen.",
    "toastResendRateLimited": "Die Einladung wurde gerade erneut gesendet. Bitte in ein paar Minuten erneut versuchen.",
    "toastRevoked": "Einladung widerrufen.",
    "toastRevokeFailed": "Widerruf fehlgeschlagen.",
    "candidateSelectBeforeInvite": "{{email}} gehört bereits zu einem bestehenden Benutzer. Wähle diesen Benutzer aus der Liste, um Zugriff zu gewähren."
  },
  "connections": {
    "addChannel": "Kanal hinzufügen",
    "addBookingPlatform": "Buchungsplattform hinzufügen",
    "mockModeBanner": "Mock-Modus — Kanäle sind simuliert, keine echten Meta- oder Buchungsplattform-Verbindungen.",
    "mockReconnectHint": "Im Mock-Modus: Mit „Erneut verbinden“ den simulierten WhatsApp-Status aktualisieren.",
    "errors": {
      "connectionIssue": "Verbindungsproblem",
      "activationRequired": "WhatsApp-Aktivierung erforderlich — geben Sie Ihre 6-stellige PIN in den Einstellungen ein"
    },
    "colChannel": "Kanal",
    "colIdentifier": "Kennung",
    "colAppliesTo": "Gilt für",
    "colStatus": "Status",
    "colActions": "Aktionen",
    "statusConnected": "Verbunden",
    "statusError": "Fehler",
    "statusSkipped": "Übersprungen",
    "statusNotConnected": "Nicht verbunden",
    "connectedSince": "Verbunden seit {{date}}",
    "connectedSinceLabel": "Verbunden seit",
    "lastSynced": "Zuletzt synchronisiert: {{time}}",
    "configure2fa": "2FA einrichten",
    "reconnect": "Erneut verbinden",
    "connect": "Verbinden",
    "emptyChannels": "Keine Kanäle konfiguriert. Fügen Sie einen hinzu.",
    "modalAddTitle": "Kanal hinzufügen",
    "channelType": "Kanaltyp",
    "addChannelTenantScopeHint": "Messaging-Kanäle gelten für alle Studios in Ihrem Konto. Sie weisen keinen Kanal einem einzelnen Studio zu.",
    "addChannelSubmit": "Kanal hinzufügen",
    "bookingReconnectTitle": "Buchungsplattform erneut verbinden",
    "bookingConnectTitle": "Buchungsplattform verbinden",
    "bookingTenantScopeHint": "Die Zugangsdaten der Buchungsplattform gelten für alle Studios in Ihrem Konto. Sie beschränken diese Integration nicht auf ein einzelnes Studio.",
    "twoFaTenantScopeHint": "Die Zwei-Faktor-Authentifizierung für Buchungen gilt auf Kontoebene für Eversports und betrifft alle Studios, die diese Buchungsverbindung nutzen.",
    "platformLabel": "Plattform",
    "bookingPlatformLabel": "Buchungsplattform",
    "selectPlatformPlaceholder": "Plattform wählen",
    "usernameEmail": "Benutzername / E-Mail",
    "usernamePlaceholder": "sie@studio.com",
    "password": "Passwort",
    "passwordPlaceholder": "••••••••",
    "updateCredentials": "Zugangsdaten aktualisieren",
    "twoFaModalTitle": "Eversports-2FA einrichten",
    "twoFaMethod": "Methode",
    "twoFaTotp": "TOTP (Authenticator-App)",
    "twoFaEmail": "E-Mail-Code",
    "twoFaSms": "SMS-Code",
    "twoFaSecretLabel": "Geheimnis / Code",
    "twoFaContactLabel": "Telefon oder E-Mail",
    "twoFaSecretPlaceholder": "TOTP-Geheimnis oder Code einfügen",
    "twoFaContactPlaceholder": "Telefonnummer oder E-Mail",
    "twoFaCodeLabel": "Authentifizierungs-Schlüssel",
    "twoFaCodePlaceholder": "TOTP-Geheimschlüssel eingeben",
    "twoFaCodeHint": "Diesen Schlüssel finden Sie in der Einrichtung Ihrer Authenticator-App (z. B. Google Authenticator, Authy). Der Code wird automatisch generiert.",
    "save": "Speichern",
    "toastStartFlowFailed": "Verbindungsablauf konnte nicht gestartet werden.",
    "toastReconnectStarted": "Erneuter Verbindungsablauf gestartet.",
    "toastReconnectFailed": "Erneutes Verbinden fehlgeschlagen.",
    "toastDisconnected": "Getrennt.",
    "toastDisconnectFailed": "Trennen fehlgeschlagen.",
    "toastBookingCredentialsUpdated": "Buchungsplattform-Zugangsdaten aktualisiert.",
    "toastBookingConnected": "Buchungsplattform verbunden.",
    "toast2faConfigured": "2FA eingerichtet.",
    "errorUserPassRequired": "Benutzername und Passwort sind erforderlich.",
    "errorSelectPlatform": "Bitte Buchungsplattform wählen.",
    "errorInvalidCredentials": "Ungültige Zugangsdaten oder Plattform nicht verfügbar. Bitte erneut versuchen.",
    "errorGenericRetry": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    "error2faSecretRequired": "Geheimnis oder Code ist erforderlich.",
    "error2faCodeRequired": "Authentifizierungs-Schlüssel ist für Eversports erforderlich.",
    "errorUpdateFailed": "Aktualisierung fehlgeschlagen.",
    "errorConnectFailed": "Verbinden fehlgeschlagen.",
    "errorConfigure2faFailed": "2FA konnte nicht eingerichtet werden.",
    "errorNoStudioForApi": "Für dieses Konto ist kein Studio verfügbar. Fügen Sie ein Studio hinzu, bevor Sie Verbindungen verwalten.",
    "channelInstagram": "Instagram",
    "channelWhatsapp": "WhatsApp",
    "channelBooking": "Buchungsplattform",
    "profile": {
      "viewProfile": "Profil anzeigen",
      "whatsappTitle": "WhatsApp-Verbindung",
      "instagramTitle": "Instagram-Verbindung",
      "sectionAssets": "Konto & Ressourcen",
      "sectionTemplates": "Nachrichtenvorlagen",
      "templatesSubtitle": "Vorlagen müssen von Meta genehmigt werden, bevor sie außerhalb des 24-Stunden-Fensters genutzt werden können.",
      "expand": "Panel erweitern",
      "collapse": "Panel verkleinern",
      "refresh": "Aktualisieren",
      "disconnect": "Trennen",
      "disconnectTitle": "Kanal trennen?",
      "disconnectBody": "Dies entfernt die Kanalverbindung für dieses Studio. Sie können später in den Einstellungen erneut verbinden.",
      "templatesPickerHint": "Genehmigte Vorlagen können in Chats beim Antworten über WhatsApp ausgewählt werden.",
      "loading": "Verbindungsdetails werden geladen…",
      "pageName": "Facebook-Seite",
      "pageId": "Seiten-ID",
      "emailTitle": "E-Mail-Verbindung",
      "providerLabel": "Anbieter",
      "providerGoogle": "Google",
      "providerMicrosoft": "Microsoft",
      "grantHealthWarning": "Ihre E-Mail-Verbindung ist abgelaufen. Verbinden Sie sie erneut, um Nachrichten zu senden und zu empfangen.",
      "errorLoadEmail": "E-Mail-Verbindungsdetails konnten nicht geladen werden."
    },
    "whatsapp": {
      "templates": {
        "create": "Nachrichtenvorlage erstellen",
        "editTitle": "Vorlage ansehen und bearbeiten",
        "editSubtitleEditable": "Kategorie oder Nachrichtentext anpassen und speichern. Meta prüft die Vorlage danach automatisch erneut.",
        "editSubtitleReadOnly": "Diese Vorlage ist ausstehend oder genehmigt und kann hier nicht bearbeitet werden.",
        "saveChanges": "Änderungen speichern",
        "saveSuccess": "Vorlage gespeichert und zur Meta-Prüfung eingereicht",
        "saveFailed": "Vorlage konnte nicht gespeichert werden",
        "nameLocked": "Der Vorlagenname kann nach der Erstellung nicht geändert werden",
        "submit": "Zur Genehmigung einreichen",
        "testSend": "Test senden",
        "preview": "Vorschau",
        "reviewPresets": "Empfohlene OktoGo-Vorlagen",
        "testSendDialogTitle": "Testnachricht senden",
        "testSendSuccess": "Testnachricht in Warteschlange",
        "testSendFailed": "Testsendung fehlgeschlagen",
        "createSuccess": "Vorlage an Meta übermittelt",
        "createFailed": "Vorlage konnte nicht erstellt werden",
        "submitFailed": "Vorlage konnte nicht zur Genehmigung eingereicht werden",
        "emptyProfile": "Noch keine Nachrichtenvorlagen. Erstellen Sie eine, um Nachrichten außerhalb des 24-Stunden-Fensters zu senden.",
        "nameHint": "Nur Kleinbuchstaben, Zahlen und Unterstriche",
        "nameInvalid": "Der Name muss Kleinbuchstaben, Zahlen und Unterstriche enthalten",
        "bodyRequired": "Vorlagentext ist erforderlich",
        "bodyLabel": "Nachrichtentext",
        "bodyPlaceholderHint": "Verwenden Sie {{1}}, {{2}}, … für dynamische Werte. Meta verlangt ein Beispiel pro Variable.",
        "variableSamplesTitle": "Variablenbeispiele für die Meta-Prüfung",
        "variableSamplesHint": "Geben Sie realistische Beispieltexte an. Meta lehnt Vorlagen ohne Beispiele ab (INVALID_FORMAT).",
        "variableSampleLabel": "Beispiel für {{index}}",
        "variableSamplePlaceholder": "Beispielwert für Meta-Prüfer",
        "variableSamplesRequired": "Geben Sie für jede Variable im Nachrichtentext ein Beispiel ein",
        "variableSampleMetaSlot": "Meta-Platzhalter {{index}}",
        "variables": {
          "customerName": "Kundenname",
          "studioName": "Studioname",
          "managerName": "Name des Managers",
          "className": "Kurs- oder Terminname",
          "classDate": "Kursdatum",
          "classTime": "Kurszeit",
          "followUpNote": "Nachricht zur Nachverfolgung",
          "visitDatetime": "Datum und Uhrzeit des Besuchs",
          "bookingDate": "Buchungsdatum",
          "bookingTime": "Buchungszeit",
          "newDate": "Neues Datum",
          "newTime": "Neue Uhrzeit",
          "spotDate": "Datum des Platzes",
          "spotTime": "Uhrzeit des Platzes",
          "handoffNote": "Übergabenachricht",
          "reengagementNote": "Reaktivierungsnachricht",
          "rebookOffer": "Angebot zur Neubuchung",
          "membershipType": "Mitgliedschaftstyp",
          "renewalDate": "Verlängerungsdatum",
          "propertyName": "Objektname",
          "checkinDate": "Check-in-Datum",
          "accessDetails": "Zugangsdetails"
        },
        "testSendTo": "An (E.164-Telefonnummer)",
        "e164Invalid": "Geben Sie eine gültige E.164-Nummer ein (z. B. +491701234567)",
        "variableLabel": "Variable {{index}}",
        "delete": "Vorlage löschen",
        "deleteConfirmTitle": "Nachrichtenvorlage löschen?",
        "deleteConfirmBody": "„{{name}}“ (Status: {{status}}) löschen? Die Vorlage wird bei Meta entfernt. Sie müssen sie ggf. erneut anlegen, um Nachrichten außerhalb des 24-Stunden-Fensters zu senden. OktoGo-Bootstrap-Vorlagen müssen ggf. neu erstellt werden.",
        "deleteConfirmAction": "Vorlage löschen",
        "deleteSuccess": "Vorlage gelöscht",
        "deleteFailed": "Vorlage konnte nicht gelöscht werden",
        "deleteNotDeletable": "Diese Vorlage kann nicht gelöscht werden, solange sie ausstehend oder genehmigt ist",
        "rejectionReason": "Ablehnungsgrund: {{reason}}",
        "presetClassReminder": "Kurs-Erinnerung mit Buchungsdetails (T-1 Demo-Sendung)",
        "presetSupportFollowup": "Manager-Follow-up nach KI-Eskalation (T-2)",
        "presetTrialWelcome": "Probetraining-Willkommen — Erstellen/Einreichen-Demo (T-3)",
        "catalog": {
          "classReminder": "Kurs- oder Terminerinnerung mit Datum, Uhrzeit und Umbuchungshinweis",
          "supportFollowup": "Manager-Follow-up nach KI-Copilot-Übergabe oder offener Anfrage",
          "trialWelcome": "Bestätigung für Probetraining oder ersten Besuch",
          "bookingConfirmed": "Buchungsbestätigung nach Studio- oder KI-Buchung",
          "bookingCancelled": "Stornierungsmitteilung mit Umbuchungsoption",
          "bookingRescheduled": "Änderung von Buchungsdatum oder -uhrzeit",
          "waitlistAvailable": "Wartelistenplatz frei — Kunde zur Buchung einladen",
          "aiHandoff": "KI-Copilot eskaliert — Manager antwortet in Kürze",
          "inactiveReengagement": "Kunde außerhalb des 24-Stunden-Fensters erneut ansprechen",
          "classCancelledStudio": "Studio hat Kurs oder Termin abgesagt",
          "membershipRenewal": "Erinnerung an Mitgliedschafts- oder Paketverlängerung",
          "stayCheckin": "Check-in-Details für Kurzzeitmiete und Ankunftshilfe"
        }
      }
    },
    "instagram": {
      "humanAgentEligible": "Human Agent berechtigt",
      "humanAgentEligibleYes": "Ja",
      "humanAgentEligibleNo": "Nein"
    },
    "webhookPending": {
      "banner": "Verbindung aktiv, aber die Nachrichtenübermittlung wartet auf Überprüfung",
      "reverify": "Webhook erneut prüfen"
    },
    "whatsappActivate": {
      "banner": "WhatsApp ist verknüpft, aber für Nachrichten noch nicht aktiviert. Geben Sie Ihre 6-stellige WhatsApp-Zwei-Schritt-PIN ein, um die Einrichtung abzuschließen.",
      "cta": "Aktivierung abschließen",
      "title": "WhatsApp-Aktivierung abschließen",
      "description": "Geben Sie die 6-stellige PIN der WhatsApp-Zwei-Schritt-Verifizierung ein. Ändern Sie die PIN nicht zuerst im WhatsApp Manager — schließen Sie die Aktivierung hier ab, damit Meta die Nummer bei der Cloud API registriert. OktoGo speichert diese PIN nicht.",
      "pinLabel": "WhatsApp-PIN",
      "pinPlaceholder": "6-stellige PIN",
      "submit": "Aktivieren",
      "cancel": "Abbrechen",
      "close": "Schließen",
      "success": "WhatsApp ist für Nachrichten aktiviert.",
      "errors": {
        "pinInvalid": "PIN stimmt nicht mit der WhatsApp-Zwei-Schritt-Verifizierung überein.",
        "reverificationRequired": "WhatsApp erfordert eine erneute Telefonverifizierung in Meta Business.",
        "rateLimited": "Zu viele Versuche. Versuchen Sie es in bis zu 72 Stunden erneut.",
        "generic": "Aktivierung fehlgeschlagen. Bitte erneut versuchen.",
        "network": "Netzwerkfehler bei der Aktivierung."
      }
    },
    "firstTrialReadiness": {
      "title": "Bereitschaft für Erstprobetraining-Links",
      "precedenceNote": "Diese Links unter Studiodaten → Allgemein bearbeiten. Verbindungen zeigt nur die Bereitschaft.",
      "scenario1Ready": "Szenario 1 bereit: Registrierungs-/Testlink konfiguriert",
      "scenario1Missing": "Szenario 1: Registrierungs-/Testlink fehlt",
      "scenario2Ready": "Szenario 2 bereit: Eversports-Studioseite konfiguriert",
      "scenario2Missing": "Szenario 2: Eversports-Studioseite fehlt",
      "ctaStudioData": "Studio-Daten öffnen",
      "ctaAiSettings": "AI-Einstellungen öffnen"
    }
  },
  "studioDataFilter": {
    "filter": "Filter",
    "clearAll": "Alle löschen",
    "panelTitle": "Filter",
    "panelDescription": "Studio-Liste nach Integrationen, Buchungsquelle und Standort eingrenzen.",
    "closeSheetAria": "Schließen",
    "sheetAriaLabel": "Studios filtern",
    "channelConnection": "{{channel}} — Verbindung",
    "sectionBookingSource": "Buchungsquelle",
    "sectionLocation": "Standort (Stadt, Land)",
    "channelInstagram": "Instagram",
    "channelWhatsapp": "WhatsApp",
    "channelBooking": "Buchung",
    "tagChannelStatus": "{{channel}}: {{status}}",
    "tagSource": "Quelle: {{source}}",
    "connectionStatus": {
      "connected": "Verbunden",
      "error": "Fehler",
      "not_connected": "Nicht verbunden"
    },
    "bookingSource": {
      "eversports": "Eversports",
      "mindbody": "Mindbody",
      "bsport": "Bsport",
      "none": "Keine",
      "other": "Andere"
    }
  },
  "studioData": {
    "activeStudioLimitReached": "Maximal 5 aktive Studios. Archivieren Sie ein Studio, bevor Sie ein weiteres erstellen.",
    "readOnlyBanner": "Sie haben nur Lesezugriff auf {{noun}}.",
    "noStudiosLinked": "Diesem Konto sind keine Studios zugeordnet.",
    "notConfiguredTab": "Nicht konfiguriert",
    "searchStudiosAria": "Studios durchsuchen",
    "tabClasses": "Kurse",
    "tabFaq": "FAQ",
    "tabGeneral": "Allgemeine Infos",
    "tabPolicies": "Richtlinien",
    "tabPrices": "Preise",
    "tabTeam": "Team",
    "tabUsers": "Nutzer",
    "tabCampaigns": "Kampagnen",
    "readOnlyHint": "Nur Inhaber und Manager können dies bearbeiten.",
    "import": {
      "action": "Importieren",
      "actionEmpty": "Aus Dokument importieren",
      "titleFaq": "In FAQ importieren",
      "titlePolicies": "In Richtlinien importieren",
      "titleGeneral": "In Allgemeine Infos importieren",
      "tabPaste": "Text einfügen",
      "tabUpload": "Datei hochladen",
      "uploadComingSoon": "Datei-Upload folgt in Kürze. Fügen Sie vorerst Ihren Dokumenttext ein.",
      "pastePlaceholder": "Handbuch, FAQ-Seite oder Richtliniendokument hier einfügen…",
      "pasteHint": "Wir schlagen strukturierte Einträge vor. Nichts wird gespeichert, bis Sie prüfen und übernehmen.",
      "pasteCharCount": "{{count}} / {{max}} Zeichen (mindestens {{min}})",
      "continue": "Weiter",
      "processing": "Dokument wird gelesen…",
      "reviewTitle": "Import prüfen",
      "reviewSummary": "{{faq}} FAQ · {{policies}} Richtlinien · {{general}} allgemeine Felder vorgeschlagen",
      "reviewSummaryGeneral": "{{general}} allgemeine Felder vorgeschlagen",
      "reviewSummaryFaq": "{{faq}} FAQ vorgeschlagen",
      "reviewSummaryPolicies": "{{policies}} Richtlinien vorgeschlagen",
      "warningsHeading": "Hinweise aus dem Import",
      "reviewEmpty": "Aus diesem Dokument gibt es nichts Neues hinzuzufügen.",
      "addSelected": "Ausgewählte hinzufügen ({{count}})",
      "back": "Zurück",
      "lowConfidence": "Geringe Zuverlässigkeit — vor dem Übernehmen prüfen",
      "conflictFaq": "Ähnliche FAQ vorhanden: {{question}}",
      "conflictPolicy": "Ähnliche Richtlinie vorhanden: {{title}}",
      "faqCapBanner": "Nur {{allowed}} von {{selected}} FAQ können hinzugefügt werden (max. 50 pro Studio)",
      "successFaq": "{{count}} FAQ-Einträge hinzugefügt",
      "successPolicies": "{{entries}} Richtlinien und {{overrides}} Überschreibungen hinzugefügt",
      "successGeneral": "{{count}} allgemeine Felder aktualisiert",
      "successMixed": "Import erfolgreich übernommen",
      "applyPartial": "{{applied}} übernommen. {{failed}} konnten nicht übernommen werden. Markierte Zeilen prüfen.",
      "rowApplyFailed": "Dieser Eintrag konnte nicht übernommen werden. Wert prüfen und erneut versuchen.",
      "selectProposal": "Vorschlag auswählen",
      "sourceExcerpt": "Quellauszug",
      "policyOverrideLabel": "Als Überschreibung für {{section}} übernehmen",
      "openingHoursStructured": "Strukturierte Öffnungszeiten werden übernommen",
      "generalField": {
        "description": "Beschreibung",
        "address": "Adresse",
        "directions": "Anfahrt",
        "firstVisitInfo": "Info zum ersten Besuch",
        "facilities": "Ausstattung",
        "openingHours": "Öffnungszeiten",
        "phone": "Telefon (Hauptnummer)",
        "email": "E-Mail (Hauptadresse)",
        "website": "Website",
        "mapsLink": "Google-Maps-Link"
      },
      "upload": {
        "dropHint": "Datei hier ablegen oder auswählen",
        "chooseFile": "Datei wählen",
        "removeFile": "Datei entfernen",
        "pasteInstead": "Stattdessen Text einfügen",
        "extracting": "Text wird aus der Datei extrahiert…",
        "pdfDisclaimer": "PDF-Extraktion kann Tabellen oder Scans auslassen. Vorschläge sorgfältig prüfen."
      },
      "errors": {
        "generic": "Import fehlgeschlagen. Bitte erneut versuchen.",
        "PREVIEW_EXPIRED": "Diese Vorschau ist abgelaufen. Text erneut einfügen.",
        "FAQ_LIMIT_REACHED": "FAQ-Limit für dieses Studio erreicht.",
        "POLICY_LIMIT_REACHED": "Richtlinien-Limit für dieses Studio erreicht.",
        "VALIDATION_ERROR": "Einige Einträge konnten nicht übernommen werden.",
        "EXTRACTION_FAILED": "Inhalt konnte nicht extrahiert werden.",
        "PREVIEW_TIMEOUT": "Verarbeitung dauerte zu lange. Kürzeres Dokument versuchen.",
        "RATE_LIMITED": "Zu viele Importversuche. Bitte warten.",
        "RATE_LIMIT_EXCEEDED": "Zu viele Importversuche. Bitte warten.",
        "KNOWLEDGE_IMPORT_DISABLED": "Import vorübergehend nicht verfügbar.",
        "FILE_TOO_LARGE": "Datei zu groß (max. 5 MB).",
        "UNSUPPORTED_FILE_TYPE": "Nicht unterstützter Dateityp.",
        "EXTRACTION_EMPTY": "Kein Text aus dieser Datei extrahiert.",
        "PASSWORD_PROTECTED_FILE": "Diese Datei ist passwortgeschützt."
      }
    },
    "addNewUnit": "Neues Studio hinzufügen",
    "archiveSuccess": "Studio archiviert.",
    "archiveError": "Studio konnte nicht archiviert werden.",
    "notConfiguredShort": "Verbinden",
    "noStudiosFound": "Keine Studios gefunden.",
    "noSearchMatch": "Keine Studios entsprechen Ihrer Suche.",
    "backToStudioList": "Zur Studio-Liste",
    "showStudioList": "Studio-Liste anzeigen",
    "expandDetailFullWidth": "Detailansicht auf volle Breite",
    "fullWidthTooltip": "Volle Breite",
    "collapseDetailDefaultWidth": "Zur Standardbreite zurückkehren",
    "moreStudioActionsAria": "Weitere Studio-Aktionen",
    "studioIdLabel": "Studio-ID",
    "archiveMenuItem": "Archivieren",
    "archiveStudioTitle": "Studio archivieren",
    "archiveStudioConfirm": "Studio wirklich archivieren?",
    "dangerZone": "Gefahrenzone",
    "archiveStudioDangerBody": "Das Studio wird ins Archiv verschoben und in aktiven Studio-Daten-Listen ausgeblendet.",
    "archiveAnyway": "Trotzdem archivieren",
    "sync": {
      "syncAll": "Alle Daten synchronisieren",
      "syncPricing": "Preise synchronisieren",
      "syncClasses": "Kurse synchronisieren",
      "syncSchedule": "Zeitplan synchronisieren",
      "syncTeam": "Team synchronisieren",
      "blockLabel": "{{block}} synchronisieren",
      "syncing": "Wird synchronisiert…",
      "lastSynced": "Zuletzt synchronisiert: {{time}}",
      "error": "Synchronisierung fehlgeschlagen. Bitte erneut versuchen.",
      "retry": "Erneut versuchen"
    },
    "tabs": {
      "campaigns": {
        "intro": "Wenn dir jemand über eine deiner Instagram-Anzeigen schreibt, kann der Assistent die Person mit genau dem Angebot willkommen heißen, das diese Anzeige beworben hat. Richte deine Kampagnen unten ein.",
        "addCampaign": "Kampagne hinzufügen",
        "groupCurrent": "Aktuell",
        "groupPast": "Vergangene Kampagnen ({{count}})",
        "rowSummary": "{{packs}} Pakete · {{ads}} Anzeigen",
        "allAdsWord": "alle",
        "statusActiveChip": "Aktiv · endet am {{date}}",
        "statusEndingSoonChip": "Endet bald · endet am {{date}}",
        "statusScheduledChip": "Geplant · startet am {{date}}",
        "statusExpiredChip": "Abgelaufen · endete am {{date}}",
        "statusNotReadyChip": "Nicht bereit",
        "versionConflict": "Diese Kampagne wurde in einer anderen Sitzung geändert. Prüfe die aktualisierte Kampagne und versuche es erneut.",
        "readinessTitle": "Bereitschaft",
        "readyChip": "Bereit",
        "openAiBehaviour": "KI-Verhalten öffnen",
        "endDateMissingHelper": "Wann endet diese Anzeigenkampagne? Der Assistent begrüßt nach diesem Datum keine neuen Interessenten mehr – du musst also nicht daran denken, sie abzuschalten.",
        "allAdsNote": "Jede Anzeige erhält dieses Angebot – wähle das nur, wenn es bei allen deinen aktuellen Anzeigen passt.",
        "toastCreateFailed": "Kampagne konnte nicht erstellt werden.",
        "toastSaveFailed": "Speichern fehlgeschlagen.",
        "loadError": "Kampagnen konnten nicht geladen werden.",
        "loadErrorRetry": "Erneut versuchen",
        "empty": {
          "title": "Noch keine Kampagnen",
          "body": "Eine Kampagne bündelt die Anzeigen, Probepakete und Zeiträume für ein Angebot. Lege eine an, um zu starten."
        },
        "missing": {
          "template": "Willkommenstext: noch nicht von OktoGo eingerichtet",
          "packs": "Füge mindestens ein Paket hinzu",
          "pack_link": "Einem Paket fehlt ein Kauflink",
          "eligible_ads": "Wähle, welche Anzeigen hierher führen",
          "valid_to": "Enddatum fehlt",
          "ad_conflict": "Anzeigenkonflikt"
        },
        "welcomeMessage": {
          "title": "Willkommensnachricht",
          "hint": "Eine Willkommensnachricht für alle Kampagnen · die erste Nachricht, die ein neuer Lead erhält, mit den Paketen dieser Kampagne",
          "placeholder": "Schreibe die Nachricht, die ein neuer Lead zuerst erhält …",
          "tabEdit": "Bearbeiten",
          "tabPreview": "Vorschau",
          "tokenHint": "Behalte {{packs}} im Text — es wird durch die Pakete dieser Kampagne ersetzt.",
          "counter": "{{current}} / {{max}}",
          "errorEmpty": "Die Willkommensnachricht darf nicht leer sein.",
          "errorMissingSlot": "Füge {{packs}} an der Stelle ein, an der die Pakete der Kampagne erscheinen sollen.",
          "versionConflict": "Diese Willkommensnachricht wurde in einer anderen Sitzung geändert. Lade neu, bevor du speicherst.",
          "translationFailed": "Diese Willkommensnachricht konnte nicht in die anderen Sprachen übersetzt werden, deshalb ist diese Version noch nicht im Einsatz. Bearbeite den Text und speichere erneut, um es noch einmal zu versuchen."
        },
        "addDialog": {
          "title": "Kampagne hinzufügen",
          "nameLabel": "Kampagnenname",
          "namePlaceholder": "z. B. Herbst-Probeangebot",
          "validFromLabel": "Beginnt",
          "validToLabel": "Endet",
          "allAdsCheckbox": "Alle meine Instagram-Anzeigen",
          "create": "Kampagne erstellen",
          "nameRequired": "Der Kampagnenname ist erforderlich.",
          "dateRangeInvalid": "Das Enddatum darf nicht vor dem Startdatum liegen."
        },
        "packsCard": {
          "title": "Probepakete für Kampagnen-Interessenten",
          "addPack": "Paket hinzufügen",
          "empty": "Noch keine Pakete. Füge eines hinzu, um Kampagnen-Interessenten ein Probeangebot zu machen.",
          "shopWide": "Shop-weites Paket",
          "linkFromEversports": "Link von Eversports",
          "linkPasted": "Link eingefügt",
          "noLinkYet": "Kurs hat noch keinen Seitenlink",
          "priceDrift": "Preis auf Eversports geändert"
        },
        "packPanel": {
          "titleNew": "Neues Paket",
          "nameLabel": "Paketname",
          "namePlaceholder": "z. B. 2+1 20-Min-Probepaket",
          "nameRequired": "Der Paketname ist erforderlich.",
          "priceLabel": "Preis",
          "currencyLabel": "Währung",
          "conditionsLabel": "Bedingungen (optional)",
          "conditionsPlaceholder": "z. B. 3 begleitete 20-Minuten-Eisbad-Kurse innerhalb von 3 Monaten",
          "linkedClassSectionTitle": "Verknüpfter Kurs",
          "pricingOptionsTitle": "Preisoptionen (dieser Kurs, von Eversports)",
          "pricingOptionsEmpty": "Für diesen Kurs sind noch keine Preisoptionen synchronisiert.",
          "purchaseLinkLabel": "Kauflink",
          "purchaseLinkPlaceholder": "https://www.eversports.at/e/…",
          "fromEversports": "von Eversports",
          "pasteALink": "Link einfügen",
          "syncClassesAndPricing": "Kurse & Preise synchronisieren",
          "readinessMissingLink": "⚠ Dieser Kurs hat noch keinen Seitenlink.",
          "linkHostWarning": "Das sieht nicht wie ein Eversports-Link aus. Kampagnenpakete werden meist auf deiner Eversports-Preisseite verkauft.",
          "priceDriftWarning": "Paketpreis hat sich bei Eversports geändert – bitte prüfen (synchronisiert {{synced}})",
          "deleteTitle": "Paket löschen?",
          "deleteDescription": "Diese Aktion kann nicht widerrufen werden.",
          "delete": "Löschen"
        },
        "classPicker": {
          "linkToClass": "Mit einem Kurs verknüpfen",
          "shopWidePack": "Shop-weites Paket — kein einzelner Kurs",
          "searchPlaceholder": "Deine Kurse durchsuchen…",
          "loading": "Deine Kurse werden geladen…",
          "noMatch": "Kein passender Kurs.",
          "addManually": "Nicht gefunden? → Kurs manuell hinzufügen",
          "hasPage": "● Seite",
          "noPage": "○ keine Seite",
          "changeClass": "Kurs ändern",
          "manualNote": "manuell eingegeben — nicht synchronisiert",
          "manual": {
            "nameLabel": "Kursname",
            "namePlaceholder": "z. B. Pure Ice Bath",
            "linkLabel": "Kurslink (Eversports-Kursseite)",
            "linkPlaceholder": "https://www.eversports.at/e/…",
            "helper": "Öffne den Kurs auf Eversports und füge dessen Seitenadresse ein (…/e/… oder …/activity/…)."
          }
        },
        "adsCard": {
          "title": "Welche Anzeigen führen hierher",
          "radioListed": "Nur die unten aufgelisteten Anzeigen",
          "radioAll": "Alle meine Instagram-Anzeigen",
          "addAd": "Anzeige hinzufügen",
          "adIdLabel": "Meta Anzeigen-ID",
          "adIdHelpAria": "Was ist eine Meta Anzeigen-ID?",
          "adIdTooltipWhy": "So erkennen wir Personen, die über diese Anzeige kommen, damit sie die Willkommensnachricht dieser Kampagne erhalten.",
          "adIdTooltipWhere": "Kopiere die Anzeigen-ID aus der Spalte „Anzeigen-ID“ im Meta Ads Manager — oder füge den Ads-Manager-Link der Anzeige direkt in dieses Feld ein.",
          "adIdPlaceholder": "z. B. 120212345678901234",
          "labelOptional": "Bezeichnung (optional)",
          "labelPlaceholder": "z. B. Sommer-Probeanzeige",
          "empty": "Noch keine Anzeigen aufgelistet.",
          "delete": "Anzeige entfernen",
          "edit": "Anzeige bearbeiten",
          "formatError": "Gib die Nummer der Anzeige ein oder füge den Meta-Ads-Manager-Link der Anzeige ein.",
          "campaignLinkError": "Dieser Link verweist auf eine Kampagne, nicht auf eine einzelne Anzeige. Öffne die Anzeige selbst im Ads Manager und füge diesen Link ein.",
          "adsetLinkError": "Dieser Link verweist auf eine Anzeigengruppe, nicht auf eine einzelne Anzeige. Öffne die Anzeige selbst im Ads Manager und füge diesen Link ein.",
          "multipleAdsError": "Dieser Link enthält mehr als eine Anzeige. Bitte füge jeweils nur eine Anzeige hinzu.",
          "duplicateError": "Diese Anzeigen-ID ist bereits aufgelistet.",
          "conflictError": "Bereits verwendet von „{{name}}“ (bis {{date}}).",
          "conflictErrorOpenEnded": "Diese Anzeige gehört zu „{{name}}“ ohne Enddatum. Lege ein Enddatum für die belegende Kampagne fest.",
          "wildcardConflictErrorOpenEnded": "Alle Anzeigen gehören zu „{{name}}“ ohne Enddatum. Lege ein Enddatum für die belegende Kampagne fest.",
          "wildcardConflictError": "„{{name}}“ beansprucht bereits alle Anzeigen in einem überlappenden Zeitraum (bis {{date}}).",
          "helperTitle": "Wie finde ich meine Meta Anzeigen-ID?",
          "helperStep1": "Öffne den Meta Ads Manager → Reiter Anzeigen.",
          "helperStep2": "Füge die Spalte „Anzeigen-ID“ hinzu (Spalten → Anpassen) — oder öffne die Anzeige und füge hier ihre ganze Adresse ein; wir finden die Nummer nach „selected_ad_ids=“.",
          "helperStep3": "Füge die Nummer hier ein — oder füge den Ads-Manager-Link der Anzeige ein, wir finden die Nummer darin.",
          "learnMore": "Mehr erfahren",
          "notSureHint": "Nicht sicher? Wähle vorerst „Alle meine Instagram-Anzeigen“ — du kannst später einschränken."
        }
      },
      "faq": {
        "saving": "Wird gespeichert…",
        "saved": "Gespeichert ✓",
        "addFaq": "FAQ hinzufügen",
        "readOnly": "Nur Lesen",
        "questionPlaceholder": "Frage",
        "answerPlaceholder": "Antwort",
        "deleteTitle": "FAQ löschen?",
        "deleteDescription": "Dies kann nicht rückgängig gemacht werden.",
        "delete": "Löschen",
        "empty": "Noch keine FAQs. Fügen Sie oben die erste hinzu.",
        "toastAdded": "FAQ hinzugefügt.",
        "toastAddFailed": "FAQ konnte nicht hinzugefügt werden.",
        "toastUpdated": "FAQ aktualisiert.",
        "toastUpdateFailed": "FAQ konnte nicht aktualisiert werden.",
        "toastDeleted": "FAQ gelöscht.",
        "toastDeleteFailed": "FAQ konnte nicht gelöscht werden."
      },
      "general": {
        "openingHours": "Öffnungszeiten",
        "closed": "Geschlossen",
        "location": "Standort",
        "description": "Beschreibung",
        "descriptionPlaceholder": "Kurze Übersicht für Kunden und die KI—Angebot, Atmosphäre und praktische Details wie Parken.",
        "address": "Adresse",
        "addressPlaceholder": "z. B. Musterstraße 42, 10115 Berlin",
        "addressInvalid": "Geben Sie eine Adresse mit Buchstaben, einer Zahl und einem Leerzeichen oder Komma ein.",
        "timezone": "Studio-Zeitzone",
        "timezonePlaceholder": "z. B. Europe/Berlin",
        "timezoneHelper": "Wird für Termine und zeitkritische Aktionen dieses Studios verwendet.",
        "timezoneInvalid": "Geben Sie eine gültige IANA-Zeitzone ein, z. B. Europe/Berlin.",
        "hoursRequired": "Legen Sie für {{day}} eine Öffnungs- und Schließzeit fest oder markieren Sie den Tag als geschlossen.",
        "hoursOutOfOrder": "Die Schließzeit für {{day}} muss nach der Öffnungszeit liegen.",
        "mapsLink": "Google-Maps-Link",
        "mapsLinkPlaceholder": "https://maps.google.com/…",
        "mapsLinkInvalid": "Geben Sie einen Google-Maps-Link ein.",
        "directions": "Wegbeschreibung",
        "directionsPlaceholder": "Anfahrt—Eingang, Etage, ÖPNV, Parken oder andere Hinweise zur Ankunft.",
        "contacts": "Kontakt",
        "phone": "Telefon (Hauptnummer)",
        "phonePlaceholder": "+49 30 1234567",
        "phoneInvalid": "Geben Sie eine Telefonnummer mit mindestens 6 Ziffern ein. Nur Ziffern und übliche Satzzeichen.",
        "email": "E-Mail (Hauptadresse)",
        "emailPlaceholder": "hallo@ihr-studio.de",
        "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        "website": "Website",
        "websitePlaceholder": "ihr-studio.de",
        "facilities": "Ausstattung",
        "facilityPlaceholder": "Ausstattung hinzufügen…",
        "add": "Hinzufügen",
        "firstVisit": "Infos zum ersten Besuch",
        "firstVisitLinks": {
          "trialRegistrationLabel": "Link zur Testanmeldung (Szenario 1)",
          "trialRegistrationPlaceholder": "ihr-studio.de/test-anmeldung",
          "trialRegistrationHelper": "Wird genutzt, wenn der Kunde noch kein Buchungsplattform-Konto hat.",
          "studioLabel": "Eversports-Studioseite (Szenario 2)",
          "studioPlaceholder": "www.eversports.com/s/ihr-studio",
          "studioHelper": "Wird genutzt, wenn der Kunde ein Eversports-Konto hat, aber neu in Ihrem Studio ist. Für allgemeine Studio-Infos bevorzugt Overview unten verwenden.",
          "overviewLabel": "Übersichtsseite",
          "overviewPlaceholder": "www.eversports.com/s/ihr-studio",
          "overviewHelper": "Öffentlicher Überblick (Über uns, Adresse, Ausstattung). Für allgemeine Studiofragen.",
          "classesLabel": "Kurskalender",
          "classesPlaceholder": "www.eversports.com/scl/ihr-studio",
          "classesHelper": "Öffentlicher Wochenkalender. Wenn Kunden fragen, was läuft oder wie man bucht.",
          "pricesLabel": "Preisseite",
          "pricesPlaceholder": "www.eversports.com/sp/ihr-studio",
          "pricesHelper": "Öffentlicher Preise-/Produktkatalog. Für Mitgliedschaften und Produktpreise.",
          "urlInvalid": "Fügen Sie die Website-Adresse hinzu, zum Beispiel rowinc.studio."
        },
        "firstVisitPlaceholder": "Was Neukunden vor dem ersten Besuch wissen sollten—Ankunft, Mitbringen, Check-in und Studio-Regeln.",
        "saveChanges": "Änderungen speichern",
        "toastSaved": "Änderungen gespeichert.",
        "toastSaveFailed": "Speichern fehlgeschlagen.",
        "weekday": {
          "monday": "Montag",
          "tuesday": "Dienstag",
          "wednesday": "Mittwoch",
          "thursday": "Donnerstag",
          "friday": "Freitag",
          "saturday": "Samstag",
          "sunday": "Sonntag"
        }
      },
      "generalPublic": {
        "heading": "Öffentliche Studio-Infos",
        "syncLabel": "Allgemein synchronisieren",
        "syncCaption": "Die Synchronisierung von Allgemein aktualisiert Ihr öffentliches „Über uns“, die Ausstattung, Instagram und die Bewertung gemeinsam.",
        "previewCaption": "Vorschaudaten — keine echten synchronisierten Studiodaten",
        "empty": "Noch nicht synchronisiert. Klicken Sie auf „Allgemein synchronisieren“, um eine Beispielvorschau der öffentlichen Infos zu sehen.",
        "aboutHeading": "Über uns",
        "amenitiesHeading": "Ausstattung",
        "amenityOffered": "Vorhanden",
        "amenityNotOffered": "Nicht vorhanden",
        "amenityUnknown": "Noch nicht synchronisiert",
        "ratingLabel": "{{value}} ({{count}} Bewertungen)"
      },
      "policies": {
        "toastSaved": "Richtlinien-Überschreibung gespeichert.",
        "toastSaveFailed": "Speichern fehlgeschlagen.",
        "toastAdded": "Richtlinie hinzugefügt.",
        "toastAddFailed": "Richtlinie konnte nicht hinzugefügt werden.",
        "toastUpdated": "Richtlinie aktualisiert.",
        "toastUpdateFailed": "Richtlinie konnte nicht aktualisiert werden.",
        "toastDeleted": "Richtlinie gelöscht.",
        "toastDeleteFailed": "Richtlinie konnte nicht gelöscht werden.",
        "syncedFrom": "Synchronisiert von {{source}}",
        "bookingPlatformFallback": "Buchungsplattform",
        "manualEntriesTitle": "Benutzerdefinierte Richtlinien",
        "addPolicy": "Richtlinie hinzufügen",
        "policyTitlePlaceholder": "Titel der Richtlinie",
        "policyContentPlaceholder": "Richtliniendetails eingeben…",
        "manualEntriesEmpty": "Noch keine benutzerdefinierten Richtlinien.",
        "deleteTitle": "Richtlinie löschen?",
        "deleteDescription": "Dieser Richtlinieneintrag wird entfernt.",
        "delete": "Löschen",
        "ownerOverride": "Inhaber-Überschreibung",
        "overridePlaceholder": "Eigenen Richtlinientext eingeben, um die synchronisierte Version zu überschreiben…",
        "saveOverride": "Überschreibung speichern",
        "overrideActive": "Inhaber-Überschreibung (aktiv)",
        "refundIfCancelledAtLeast": "Rückerstattung bei Stornierung mindestens",
        "beforeClassStart": "vor Kursbeginn",
        "hoursBeforeClassStart": "Stunden vor Kursbeginn",
        "hoursPreset": "{{count}} Stunden",
        "hoursCustom": "Benutzerdefiniert…",
        "toastInvalidHours": "Geben Sie eine ganze Stundenzahl zwischen 1 und 168 ein.",
        "customHoursAria": "Benutzerdefinierte Stunden",
        "hoursInfoAria": "Mehr zu dieser Regel",
        "hoursInfoTitle": "Zu dieser Zahl",
        "hoursInfoCredit": "Kursguthaben oder Pass zurück — keine Bankrückerstattung.",
        "hoursInfoMove": "Dieselben Stunden, wenn sie den Kurs verschieben möchten.",
        "hoursInfoNumberBeatsNotes": "Copilot folgt dieser Zahl, nicht den Notizen darunter.",
        "hoursPreview": "Kunden, die {{hours}} Stunden oder mehr vor Kursbeginn stornieren, können ein Kursguthaben oder den Pass zurückerhalten. Später: Stornieren oder Verschieben möglich, kein Guthaben.",
        "additionalNotes": "Zusätzliche Stornierungshinweise (optional)",
        "additionalNotesHint": "Ausnahmen, Krankheit, Kündigungsfrist — Copilot kann diese erklären. Sie ändern die Stunden oben nicht.",
        "additionalNotesPlaceholder": "Zusätzliche Richtlinienhinweise eingeben…",
        "saveAdditionalNotes": "Speichern",
        "additionalNotesActive": "Zusätzliche Hinweise",
        "empty": "Noch keine Richtlinienabschnitte. Verbinden Sie eine Buchungsplattform, um Richtlinientext zu synchronisieren.",
        "syncCancellationPolicy": "Stornierungsrichtlinie synchronisieren",
        "syncRefundPolicy": "Erstattungsrichtlinie synchronisieren",
        "cancellationPolicyEmpty": "Noch nicht öffentlich veröffentlicht — nichts erfunden. Klicken Sie auf „Stornierungsrichtlinie synchronisieren“, um erneut zu prüfen.",
        "refundPolicyEmpty": "Noch nicht öffentlich veröffentlicht — nichts erfunden. Klicken Sie auf „Erstattungsrichtlinie synchronisieren“, um erneut zu prüfen.",
        "refundPolicyPreviewLine": "Vorschau — kein echter importierter Richtlinientext: „Volle Erstattung bis 24 Stunden vor Kursbeginn; danach Kursguthaben.“"
      },
      "prices": {
        "syncCaption": "Die Preis-Synchronisierung aktualisiert diesen Tab und die Preisoptionen jedes Kurses gemeinsam.",
        "previewCaption": "Vorschaudaten — keine Live-Eversports-Preise",
        "membershipsHeading": "Mitgliedschaften",
        "membershipsEmpty": "Noch nicht synchronisiert. Klicken Sie auf „Preise synchronisieren“, um Beispiel-Mitgliedschaften anzuzeigen.",
        "productsHeading": "Produkte",
        "productsEmpty": "Noch nicht synchronisiert. Klicken Sie auf „Preise synchronisieren“, um Beispielprodukte anzuzeigen.",
        "minRuntime_one": "{{count}} Monat Mindestlaufzeit",
        "minRuntime_other": "{{count}} Monate Mindestlaufzeit"
      },
      "team": {
        "syncCaption": "Die Team-Synchronisierung aktualisiert diesen Tab mit dem Trainerverzeichnis von Ihrer öffentlichen Eversports-Seite.",
        "previewCaption": "Vorschaudaten — kein echtes Trainerverzeichnis",
        "heading": "Trainer",
        "empty": "Noch nicht synchronisiert. Klicken Sie auf „Team synchronisieren“, um Beispiel-Trainer anzuzeigen.",
        "viewSchedule": "Zeitplan ansehen"
      },
      "users": {
        "selectStudio": "Wählen Sie ein Studio, um Nutzer zu verwalten.",
        "peopleWithAccessLead": "Personen mit Zugang zu",
        "peopleWithAccessTrail": ".",
        "thisStudio": "diesem Studio",
        "addMember": "Mitglied hinzufügen",
        "inviteTitle": "Teammitglied einladen",
        "email": "E-Mail",
        "managerInviteShort": "Manager können nur Mitarbeiter einladen.",
        "sendInvitation": "Einladung senden",
        "revokeHintAddMember": "Sie können später unter „Mitglied hinzufügen“ erneut eine Einladung senden.",
        "emptyTeam": "Noch keine Teammitglieder oder ausstehenden Einladungen."
      },
      "sidePanel": {
        "title": "Neues Studio hinzufügen",
        "studioName": "Studio-Name",
        "namePlaceholder": "Studio-Namen eingeben",
        "nameRequired": "Studio-Name ist erforderlich.",
        "nameTooShort": "Der Studio-Name muss mindestens 2 Zeichen lang sein.",
        "nameTooLong": "Der Studio-Name darf höchstens 60 Zeichen lang sein.",
        "nameAlreadyExists": "Dieser Studio-Name existiert bereits.",
        "nameArchivedConflict": "Dieser Name entspricht einem archivierten Studio. Stellen Sie das archivierte Studio zuerst wieder her oder benennen Sie es um.",
        "studioLimitReached": "Maximal 5 aktive Studios. Archivieren Sie ein Studio, bevor Sie ein weiteres erstellen.",
        "description": "Beschreibung",
        "descriptionPlaceholder": "Studio-Beschreibung eingeben",
        "descriptionTooLong": "Die Beschreibung darf höchstens 200 Zeichen lang sein.",
        "descriptionCharCount": "{{current}}/{{max}}",
        "teamMembers": "Teammitglieder",
        "teamHint": "Laden Sie Personen nach der Studioerstellung ein oder geben Sie unten Namen und E-Mails ein, um automatisch einzuladen.",
        "memberNamePlaceholder": "Vollständiger Name",
        "memberNameRequired": "Name ist erforderlich.",
        "memberNameAria": "Name der eingeladenen Person",
        "memberEmailAria": "E-Mail der eingeladenen Person",
        "emailPlaceholder": "email@beispiel.com",
        "emailRequired": "E-Mail ist erforderlich.",
        "emailInvalid": "Geben Sie eine gültige E-Mail-Adresse ein.",
        "emailDuplicate": "Diese E-Mail steht bereits in der Liste.",
        "addMemberButtonAria": "Teammitglied zur Liste hinzufügen",
        "editMemberAria": "Teammitglied bearbeiten",
        "saveMemberEdit": "Mitglied speichern",
        "finishEditingFirst": "Speichern oder brechen Sie die Bearbeitung ab, bevor Sie das Studio erstellen.",
        "removeAria": "Entfernen",
        "cancel": "Abbrechen",
        "create": "Studio erstellen",
        "toastInvalidEmail": "Bitte gültige E-Mail eingeben.",
        "toastDuplicateEmail": "Diese E-Mail steht bereits in der Liste.",
        "toastCreateFailed": "Studio konnte nicht erstellt werden.",
        "toastInviteFailed": "Einladung an {{email}} konnte nicht gesendet werden.",
        "toastCreated": "Studio erstellt.",
        "toastGrantFailedExisting": "Zugriff für {{email}} in diesem Studio konnte nicht gewährt werden.",
        "toastGrantAlreadyMemberExisting": "{{email}} ist bereits Mitglied dieses neuen Studios."
      },
      "trace": {
        "panelTitle": "Vision-Agent-Trace",
        "closeAria": "Schließen",
        "enterFullscreenAria": "Auf Vollbild erweitern",
        "exitFullscreenAria": "Vollbild beenden",
        "backToClasses": "Zurück zu Kursen",
        "pageTitle": "Vision-Agent-Trace",
        "pageSubtitle": "Wählen Sie einen Lauf aus der Liste (ClickHouse-Audit) oder fügen Sie eine Run-ID ein. Für Screenshots und Downloads ist S3 erforderlich.",
        "selectStudioForTraces": "Wählen Sie ein Studio, um Traces zu laden.",
        "recentRuns": "Letzte Agent-Läufe",
        "window": "Zeitraum",
        "daysOption": "{{count}} Tage",
        "refresh": "Aktualisieren",
        "clickHouseNoList": "Keine Agent-Läufe in diesem Zeitraum. ClickHouse-Audit ist nicht konfiguriert, daher stammt diese Liste aus dem lokalen Postgres-Audit-Log. Nutzen Sie unten „Run-ID“, falls Sie eine UUID haben.",
        "loadingRuns": "Läufe werden geladen…",
        "lastActivity": "Letzte Aktivität",
        "platform": "Plattform",
        "lastEvent": "Letztes Ereignis",
        "events": "Ereignisse",
        "estimatedLlmCostColumn": "Geschätzte LLM-Kosten",
        "runsListTotalEstimatedLlmCost": "Summe der angezeigten Läufe (LLM geschätzt): {{amount}}",
        "runsListCostDisclaimer": "Beträge sind In-App-Schätzungen aus Token-Nutzung (Listenpreis-Heuristiken), keine Rechnungen.",
        "runIdLabel": "Run-ID (optional)",
        "runIdSrOnly": "Agent-Run-ID",
        "runIdPlaceholder": "UUID einfügen, falls nicht in der Liste",
        "loadTrace": "Trace laden",
        "loadError": "Trace konnte nicht geladen werden.",
        "syncComplete": "Synchronisation abgeschlossen",
        "syncFailed": "Synchronisation fehlgeschlagen",
        "runLoaded": "Lauf geladen",
        "linkPlaywrightTrace": "Playwright-Trace",
        "linkRecording": "Aufzeichnung",
        "linkHar": "HAR",
        "linkLlmDecisions": "LLM-Entscheidungen",
        "latestStepAlt": "Letzter Schritt",
        "classesSynced": "{{count}} Kurse synchronisiert",
        "percentComplete": "100%",
        "llmTotalLabel": "LLM gesamt:",
        "llmCallsCount": "({{count}} Aufrufe)",
        "failureHeading": "Fehler-Screenshot",
        "failureAlt": "Fehler",
        "s3NotConfigured": "S3-Agent-Traces sind auf diesem Server nicht konfiguriert; Screenshots und Downloads sind nicht verfügbar.",
        "durationMs": "{{n}} ms",
        "durationSeconds": "{{n}} s",
        "runDurationSuffix": " · {{n}} s",
        "tokensSummary": "{{input}} in / {{output}} out ({{total}} Tokens)",
        "orchestratorTraceHeading": "Chat-Orchestrator-Trace",
        "intent": "Intent",
        "confidence": "Konfidenz",
        "decisionOrigin": "Entscheidung",
        "groundingVerdict": "Grounding",
        "escalationReason": "Eskalation",
        "toolsCalled": "Tools",
        "toolOutcome": "Tool-Ergebnis",
        "ragChunks": "RAG",
        "decisionSteps": "Entscheidungsschritte",
        "llmTemperature": "Temp {{value}}",
        "llmMaxTokens": "max {{value}} Tok",
        "expandDetails": "Details",
        "collapseDetails": "Ausblenden",
        "executionRoute": "Route",
        "interactionMode": "Modus",
        "subFlow": "Subflow",
        "method": "Methode",
        "selfHealed": "Selbstheilung",
        "systemPrompt": "System",
        "userPrompt": "User",
        "llmResponse": "Antwort",
        "llmPromptKey": "Prompt",
        "llmPromptSummary": "Struktur",
        "llmReasoning": "Begründung",
        "promptKind": "Art",
        "workflowLiveBadge": "Live",
        "workflowReplayBadge": "Wiedergabe",
        "workflowTopologyTitle": "Workflow-Topologie",
        "workflowEventsCount": "{{count}} Live-Ereignisse",
        "cascadeOf": "Folgefehler nach Root-Fehler {{rootCauseId}}",
        "technicalDetails": "Technische Details",
        "openConversation": "Unterhaltung öffnen",
        "privacyHiddenContent": "(Inhalt aus Datenschutzgründen ausgeblendet)",
        "tier": {
          "decisionLabel": "Tier-Entscheidung",
          "name": {
            "json_feed": "JSON-Feed",
            "dom_text_early": "DOM-Text (früh)",
            "dom_script": "DOM-Skript",
            "cli_playwright": "CLI Playwright",
            "mcp_text": "MCP-Text",
            "vision_agent": "Vision-Agent"
          },
          "outcome": {
            "success": "Erfolg",
            "fail": "Fehlgeschlagen",
            "skip": "Übersprungen"
          },
          "reason": {
            "skip_anonymous_or_non_schedule": "Übersprungen (anonym / kein Stundenplan)",
            "skip_dom_not_applicable": "Übersprungen (DOM nicht anwendbar)",
            "disabled_by_config": "Per Konfiguration deaktiviert",
            "consecutive_failures": "Wiederholte Fehler",
            "llm_last_resort_enabled": "LLM-Notfallmodus aktiv",
            "range_mismatch": "Datumsbereich passt nicht",
            "empty_feed": "Leerer Feed",
            "tier_timeout": "Tier-Zeitüberschreitung",
            "tier_error": "Tier-Fehler",
            "selector_not_found": "Selektor nicht gefunden",
            "initial_navigation_failed": "Initiale Navigation fehlgeschlagen",
            "auth_retry_limit": "Auth-Wiederholungslimit erreicht",
            "reauth_failed": "Erneute Anmeldung fehlgeschlagen",
            "no_meaningful_result": "Kein verwertbares Ergebnis"
          }
        }
      },
      "classes": {
        "weekdayMon": "Mo",
        "weekdayTue": "Di",
        "weekdayWed": "Mi",
        "weekdayThu": "Do",
        "weekdayFri": "Fr",
        "weekdaySat": "Sa",
        "weekdaySun": "So",
        "viewList": "Liste",
        "viewCalendar": "Kalender",
        "syncComplete": "Synchronisation abgeschlossen",
        "syncFailed": "Synchronisation fehlgeschlagen",
        "syncing": "Synchronisiert…",
        "viewTrace": "Trace anzeigen",
        "latestStepAlt": "Letzter Schritt",
        "agentScreenshots": "Agent-Screenshots ({{count}})",
        "stepLabel": "Schritt {{n}}",
        "tableClass": "Kurs",
        "tableInstructor": "Trainer",
        "tableTime": "Zeit",
        "tableDuration": "Dauer",
        "tableLevel": "Niveau",
        "tableSpots": "Plätze im nächsten Kurs",
        "minutes": "{{n}} Min.",
        "spotsLeft": "{{n}} frei",
        "full": "Voll",
        "emptyList": "Noch keine Kurse synchronisiert. Verbinden Sie eine Buchungsplattform und starten Sie eine Synchronisation.",
        "detailStudio": "Studio",
        "detailLocation": "Ort",
        "detailTrainer": "Trainer",
        "detailTime": "Zeit",
        "detailCapacity": "Kapazität",
        "detailDuration": "Dauer",
        "about": "Über",
        "descriptionEmpty": "Noch keine Klassenbeschreibung synchronisiert.",
        "pricingOptions": "Buchbare Optionen dieses Kurses",
        "pricingOptionsEmpty": "Preisoptionen noch nicht verfügbar. Copilot erfindet keine Preise.",
        "links": "Links",
        "classPageLink": "Klassenseite öffnen",
        "bookingLink": "Buchungslink öffnen",
        "bookSlot": "Buchen",
        "clients": "Kunden ({{count}})",
        "bookingConfirmed": "Bestätigt",
        "bookingWaitlisted": "Warteliste",
        "bookingCancelled": "Storniert",
        "bookingCheckedIn": "Eingecheckt",
        "upcomingSchedule": "Kommende Termine",
        "noUpcomingSessions": "Keine anstehenden Termine in diesem Zeitraum.",
        "showNextMonth": "Nächsten Monat anzeigen",
        "showNextMonthAria": "Nächsten Monat anzeigen",
        "loading": "Wird geladen…",
        "toastSyncComplete": "Synchronisation erfolgreich abgeschlossen.",
        "toastSyncFailed": "Synchronisation fehlgeschlagen.",
        "toastSyncBookingPlatformNotConfigured": "Verbinde zuerst eine Buchungsplattform (Eversports, Mindbody oder Bsport), bevor du synchronisierst.",
        "syncLogInit": "Synchronisation starten für {{start}} → {{end}}…",
        "syncLogStarted": "Synchronisationsauftrag auf dem Server gestartet",
        "syncLogScreenshots": "{{count}} Agent-Screenshots geladen",
        "syncLogCompleted": "Synchronisation abgeschlossen",
        "syncLogFailedMsg": "Synchronisation fehlgeschlagen",
        "syncStartError": "Synchronisation konnte nicht gestartet werden"
      }
    }
  },
  "chats": {
    "loadingChats": "Konversationen werden geladen…",
    "noConversations": "Keine Konversationen gefunden.",
    "noConversationsMatchFilters": "Keine Konversationen entsprechen Ihrer Suche oder Ihren Filtern.",
    "listLoadFailed": "Konversationen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "studioContextRequired": "Der Studio-Kontext ist nicht korrekt gesetzt. Wechseln Sie zu einem Studio oder versuchen Sie es erneut.",
    "studioContextRetry": "Erneut versuchen",
    "studioContextSwitchStudio": "Zu einem Studio wechseln",
    "unreadConversation": "Ungelesene Konversation mit {{name}}",
    "unreadConversationCount": "Ungelesene Konversation mit {{name}}, {{count}} ungelesene Nachrichten",
    "session": {
      "filterBarTitle": "Gefiltert: Session läuft ab",
      "filterBarHint": "Es werden Threads angezeigt, deren Messaging-Session bald endet oder für Freiform bereits abgelaufen ist.",
      "clearSessionFilter": "Alle Chats anzeigen",
      "filterEmpty": "Keine Chats passen zum Session-Filter in dieser Ansicht. Filter aufheben oder den Studio-Kontext wechseln.",
      "bannerExpiringTitle": "WhatsApp-Session endet bald",
      "bannerExpiringBody": "Freiform-Antworten sind noch für {{time}} möglich. Danach kann Meta eine genehmigte Vorlage oder eine neue Kundennachricht verlangen.",
      "bannerExpiredTitle": "WhatsApp-Session für Freiform beendet",
      "bannerExpiredBody": "Dieser Thread liegt außerhalb des üblichen 24-Stunden-Kundenfensters. Senden kann fehlschlagen, bis Sie eine genehmigte Vorlage nutzen oder der Kunde wieder schreibt.",
      "composerExpiredHelp": "Die freien Antworten sind blockiert. Wählen Sie oben im Entwurfsbereich eine genehmigte Nachrichtenvorlage.",
      "composerClosedInstagram": "Es sind mehr als 7 Tage vergangen. Bitten Sie den Kunden, Ihnen erneut zu schreiben, bevor Sie antworten können.",
      "rowAriaExpiringWhatsApp": "WhatsApp-Session läuft bald ab",
      "rowAriaExpiredWhatsApp": "WhatsApp-Session für Freiform abgelaufen",
      "rowTooltipExpiringWhatsApp": "Session endet in {{time}}",
      "rowTooltipExpiredWhatsApp": "Session abgelaufen — Vorlagen oder neue Kundennachricht",
      "rowAriaSessionExpiring": "Messaging-Session läuft bald ab",
      "rowAriaSessionExpired": "Messaging-Session für Freiform abgelaufen",
      "rowTooltipExpiringInstagram": "Antwortfenster endet in {{time}}",
      "rowTooltipExpiredInstagram": "Außerhalb von 24 h — nur manuelle Antworten, bis zu 7 Tage",
      "bannerExpiringTitleInstagram": "Antwortfenster endet bald",
      "bannerExpiringBodyInstagram": "Antworten noch für {{time}} möglich. Antworten Sie bald oder warten Sie auf eine neue Nachricht des Kunden.",
      "bannerExpiredTitleInstagram": "Außerhalb des 24-Stunden-Antwortfensters",
      "bannerExpiredBodyInstagram": "Außerhalb des 24-Stunden-Fensters (bis zu 7 Tage): Nur manuelle Antwort, oder Vorgeschlagene Antwort prüfen, bearbeiten und manuell senden.",
      "bannerClosedTitleInstagram": "Antwort auf Instagram nicht möglich",
      "bannerClosedBodyInstagram": "Es sind mehr als 7 Tage vergangen. Bitten Sie den Kunden, Ihnen erneut zu schreiben.",
      "headerSupportWindowInstagram": "Supportfenster · vor {{time}}"
    },
    "emptyStateTitle": "Konversation auswählen",
    "emptyStateSubtitle": "Wählen Sie in der Liste eine Konversation, um die Nachrichten anzuzeigen.",
    "customerInfo": "Kundeninfo",
    "customerInfoTitle": "Kundeninfo",
    "details": {
      "title": "Kundendetails",
      "show": "Kundendetails anzeigen",
      "hide": "Kundendetails ausblenden",
      "collapseAria": "Kundendetails-Bereich einklappen",
      "expandAria": "Kundendetails-Bereich ausklappen",
      "resizeAria": "Kundendetails-Bereich skalieren",
      "placeholderLoading": "Kundendetails werden geladen…",
      "sectionGeneral": "Allgemein",
      "sectionStudios": "Studios",
      "sectionDocuments": "Dokumente",
      "sectionClasses": "Kurse",
      "upcomingClassesToggle": "Nächst anstehende Kurse",
      "upcomingClassesEmpty": "—",
      "classesLast": "Letzte",
      "classesNext": "Nächste",
      "confirmIdentity": "Identität bestätigen",
      "confirmIdentityHelp": "Markiert diesen Kunden in diesem Chat als identifiziert und entsperrt blockierte Entwurfsfreigaben."
    },
    "composer": {
      "collapseAria": "Antwortfeld einklappen",
      "expandAria": "Antwortfeld ausklappen"
    },
    "escalated": "Eskaliert",
    "escalatedDraftPending": "Vorgeschlagene Antwort bereit — vor dem Senden prüfen",
    "escalationKind": {
      "soft": "Prüfung nötig",
      "hard": "Menschliche Übernahme"
    },
    "escalationFamily": {
      "human_requested": "Kunde hat um einen Menschen gebeten",
      "tool_or_platform_failure": "Tool- oder Plattformfehler",
      "availability_unverified": "Verfügbarkeit nicht geprüft",
      "no_availability": "Keine buchbaren Kurse",
      "account_read_failed": "Kontolesung fehlgeschlagen",
      "conversation_stall": "Gespräch festgefahren",
      "low_confidence_or_scope": "Außerhalb des Bereichs oder unsicher",
      "frustration": "Kunde frustriert",
      "max_exchanges": "Maximale Austauschzahl erreicht",
      "identity_verification": "Identitätsprüfung nötig",
      "policy_restricted": "Eingeschränktes Thema",
      "manual": "Manuell eskaliert",
      "ai_unavailable": "KI nicht verfügbar",
      "named_set_unfinished": "Stornierung nicht abgeschlossen",
      "cancellation_refused": "Stornierung abgelehnt"
    },
    "leadWhy": {
      "structured": "Aus Anzeige",
      "inferred": "Abgeleitet"
    },
    "campaignLeadPreparation": {
      "title": "Kampagnen-Willkommensnachricht vorbereitet",
      "closedTitle": "Kampagnenvorgang geschlossen",
      "activeTitle": "Kampagnen-Willkommensnachricht aktiv",
      "notSent": "Nicht gesendet",
      "closed": "Geschlossen",
      "active": "Aktiv",
      "activeBody": "Der Anbieter hat die Kampagnen-Willkommensnachricht angenommen. Die Episode wartet auf die Paketauswahl des Kunden.",
      "closedBody": "Die Kampagnenautomatisierung wurde für diesen Vorgang beendet.",
      "terminal": {
        "purchase_verified": "Kauf bestätigt",
        "member_discovered": "Bestehendes Mitglied gefunden",
        "explicit_decline": "Kunde hat abgelehnt",
        "manager_takeover": "Manager hat übernommen"
      },
      "awaitingPack": "Warten auf Paketauswahl",
      "packSelected": "Paket ausgewählt: {{name}}",
      "linkReady": "Kauflink bereit: {{name}}",
      "purchaseClaimUnverified": "Kauf gemeldet · Prüfung erforderlich",
      "bodyAuto": "Die Kampagnendaten sind festgehalten. Die Willkommensnachricht ist für den automatischen Versand vorgemerkt.",
      "bodyManual": "Die Kampagnendaten sind festgehalten. Prüfe und sende die Kampagnen-Willkommensnachricht unten im Antwortvorschlag.",
      "modeAuto": "Automatische Vorbereitung · Versand vorgemerkt",
      "modeManual": "Manuelle Vorbereitung · Prüfung erforderlich",
      "campaign": "{{name}} · Version {{version}}",
      "campaignFallback": "Kampagne · Version {{version}}",
      "packs": "Vorbereitete Pakete",
      "purchaseLink": "Kauflink"
    },
    "resolved": "Erledigt",
    "resolvedButton": "Als erledigt markieren",
    "messageDeliveryFailedHumanAgentTitle": "Instagram-Antwort konnte nicht zugestellt werden",
    "messageDeliveryFailedHumanAgentBody": "Der Instagram Human Agent ist für diese App noch nicht freigegeben, daher konnte diese Nachricht den Kunden nicht erreichen. Bitten Sie den Kunden, Ihnen erneut zu schreiben, um kostenlose Antworten wieder zu öffnen, oder fahren Sie auf WhatsApp fort, wenn dieses verbunden ist.",
    "messageDeliveryFailedBubble": "Kunde nicht erreicht",
    "resolve": "Erledigen",
    "escalate": "Eskalieren",
    "archive": "Archivieren",
    "moreChatActions": "Weitere Chat-Aktionen",
    "chatIdLabel": "Chat-ID",
    "loadingOlder": "Ältere Nachrichten werden geladen…",
    "loadOlderMessages": "Ältere Nachrichten laden",
    "customerFallback": "Kunde",
    "senderSystem": "System",
    "loadingMessages": "Nachrichten werden geladen…",
    "draftBlockedDefault": "Der Kunde muss identifiziert sein, bevor Kontovorgänge freigegeben werden können.",
    "draftBlockedHumanHandling": "Dieses Gespräch wurde bereits an Ihr Team übergeben — dieser Vorschlag beantwortet möglicherweise eine frühere Nachricht.",
    "draftStaleHeadReleased": "Das Gespräch hat sich weiterentwickelt, seit diese Antwort geschrieben wurde.",
    "draftStaleHeadReleasedRecovery": "Bearbeiten Sie sie vor dem Senden oder antworten Sie mit Ihren eigenen Worten.",
    "draftStaleHeadReleasedRefusal": "Diese vorgeschlagene Antwort ist nicht mehr aktuell — das Gespräch hat sich seitdem weiterentwickelt. Ändern Sie den Text, bevor Sie ihn senden, oder antworten Sie mit Ihren eigenen Worten.",
    "listJustNow": "Gerade eben",
    "listMinsShort": "vor {{count}} Min.",
    "listHoursShort": "vor {{count}} Std.",
    "listDaysShort": "vor {{count}} T.",
    "threadToday": "Heute",
    "threadYesterday": "Gestern",
    "emojiSearchPlaceholder": "Emoji suchen",
    "emojiSkinToneAria": "Emoji-Hautfarbe ändern",
    "emojiCategoryRecent": "Zuletzt verwendet",
    "emojiCategoryAll": "Alle Emojis",
    "emojiCategorySmileys": "Smileys und Personen",
    "emojiCategoryPeople": "Gesten und Personen",
    "emojiCategoryHearts": "Herzen und Feiern",
    "emojiCategoryTravel": "Reisen und Orte",
    "emojiCategorySymbols": "Symbole und Status",
    "resolvedModalConfirm": "Als erledigt markieren",
    "typeMessagePlaceholder": "Nachricht eingeben…",
    "editTitle": "Bearbeiten",
    "senderAi": "KI",
    "senderTeam": "Team",
    "connectPlatformHint": "Verbinden Sie in Einstellungen → Kanäle eine Buchungs-{{listingFragment}}plattform, um verknüpfte Mitglieds- oder Gastdaten hier anzuzeigen.",
    "connectPlatformListingFragment": "oder Listing-",
    "connectPlatformListingEmpty": "",
    "searchManually": "Manuell suchen",
    "trial": "Testphase",
    "firstTrial": {
      "staffHint": {
        "scenario1": "Erstbesuch / Probe — Szenario 1 (kein Konto auf der Buchungsplattform). Nur für das Team.",
        "scenario2": "Erstbesuch / Probe — Szenario 2 (Konto vorhanden, neu im Studio). Nur für das Team."
      },
      "linksNotReady": {
        "title": "Link für Erstprobetraining fehlt",
        "reason": {
          "missing_trial_registration_link": "Fügen Sie den Registrierungs- / Probelink hinzu, bevor Copilot diesen Probepfad automatisch senden kann.",
          "missing_studio_trial_booking_link": "Fügen Sie den Studio-Link hinzu, bevor Copilot diesen Probepfad automatisch senden kann.",
          "unknown": "Fügen Sie die erforderlichen Erstprobetraining-Links hinzu, bevor Copilot diesen Probepfad automatisch senden kann."
        },
        "cta": "Allgemeine Infos öffnen"
      }
    },
    "completedWriteClash": {
      "title": "Entwurf widerspricht einer abgeschlossenen Aktion",
      "body": "Die Buchungsplattform bestätigt, dass diese Aktion in diesem Zug abgeschlossen wurde, aber der Entwurf sagt dem Kunden weiterhin, er sei nicht berechtigt. Bearbeiten Sie die Antwort, bevor Sie sie freigeben."
    },
    "groundedFailure": {
      "title": "Faktenbasierte Antwort muss geprüft werden",
      "facts": "Gefundene Fakten",
      "reason": "Prüfproblem"
    },
    "proposedAction": {
      "FIRST_TRIAL_LINKS_NOT_READY": "Konfigurieren Sie die Probelinks in Studio-Daten, bevor Copilot diesen Probepfad automatisch senden kann.",
      "GROUP_MANUAL_FULFILLMENT": "Gruppen- oder Teambuchungen müssen vom Studio-Team manuell erfüllt werden."
    },
    "campaignSend": {
      "campaign_ended": "Diese Kampagne ist beendet oder nicht mehr aktiv, daher wurde die Willkommensnachricht nicht gesendet.",
      "instagram_window_closed": "Das Instagram-Antwortfenster für diesen Kunden ist geschlossen, daher wurde die Willkommensnachricht nicht gesendet.",
      "human_handling": "Ein Teammitglied hat diese Unterhaltung übernommen, daher wurde die Willkommensnachricht der Kampagne nicht gesendet.",
      "customer_is_member": "Dieser Kunde ist bereits Mitglied, daher wurde die Willkommensnachricht der Kampagne nicht gesendet.",
      "newer_customer_message": "Der Kunde hat erneut geschrieben, nachdem diese Willkommensnachricht vorbereitet wurde, daher wurde sie nicht gesendet.",
      "campaign_paused": "Der Kampagnenversand ist für dieses Studio derzeit pausiert, daher wurde die Willkommensnachricht nicht gesendet.",
      "instagram_not_connected": "Die Instagram-Verbindung dieses Studios konnte nicht bestätigt werden. Prüfen Sie die Verbindung in den Einstellungen und versuchen Sie es dann erneut.",
      "send_in_progress": "Ein anderer Versand an diesen Kunden läuft noch. Warten Sie, bis er abgeschlossen ist, bevor Sie es erneut versuchen; das kann eine Minute dauern.",
      "cooldown_or_capacity": "Dieser Kunde hat das Limit für Kampagnen-Willkommensnachrichten vorerst erreicht, daher wurde die Nachricht nicht gesendet.",
      "draft_changed": "Dieser Entwurf stimmt nicht mehr mit der vorbereiteten Kampagnennachricht überein. Aktualisieren Sie die Unterhaltung, bevor Sie es erneut versuchen.",
      "group_booking_active": "In dieser Unterhaltung ist noch ein Gruppenbuchungsvorschlag offen, daher wurde die Willkommensnachricht der Kampagne nicht gesendet. Klären oder verwerfen Sie zuerst diesen Vorschlag.",
      "no_customer_message": "In dieser Unterhaltung gibt es noch keine Kundennachricht, daher wurde die Willkommensnachricht der Kampagne nicht gesendet.",
      "internal": "Die Willkommensnachricht der Kampagne konnte nicht gesendet werden, weil eine interne Prüfung fehlgeschlagen ist. Versuchen Sie es später erneut oder wenden Sie sich an den Support.",
      "customer_refused": "Dieser Kunde hat die Kampagne abgelehnt, daher wurde keine Willkommensnachricht gesendet.",
      "customer_reply_pending_check": "Die letzte Kundenantwort wird noch geprüft, daher wurde die Willkommensnachricht noch nicht gesendet. Versuchen Sie es gleich erneut.",
      "campaign_updated": "Die Kampagne wurde geändert, nachdem diese Willkommensnachricht vorbereitet wurde, daher wurde sie noch nicht gesendet. Die Nachricht entspricht jetzt dem aktuellen Angebot. Prüfen Sie sie und tippen Sie dann erneut auf Senden.",
      "campaign_updated_edited": "Die Kampagne wurde geändert, nachdem diese Willkommensnachricht vorbereitet wurde, daher wurde sie noch nicht gesendet. Ihr bearbeiteter Text wurde beibehalten. Prüfen Sie darin Pakete und Preise und tippen Sie dann erneut auf Senden.",
      "welcome_too_long": "Diese Willkommensnachricht ist zu lang für eine Instagram-Nachricht, daher wurde sie nicht gesendet. Kürzen Sie sie und tippen Sie dann erneut auf Senden.",
      "welcome_capacity_reached": "Dieser Kunde hat von diesem Studio bereits die maximale Anzahl von zwei Kampagnen-Willkommensnachrichten erhalten, daher wurde die Nachricht nicht gesendet.",
      "welcome_cooldown_active": "Dieser Kunde hat in den letzten 30 Tagen eine Kampagnen-Willkommensnachricht von diesem Studio erhalten, daher wurde die Nachricht nicht gesendet. Eine neue Willkommensnachricht ist nach Ablauf der 30 Tage möglich.",
      "campaign_episode_active": "Mit diesem Kunden läuft noch eine Kampagnen-Unterhaltung, daher wurde keine zweite Willkommensnachricht gesendet.",
      "campaign_episode_ended": "Eine frühere Kampagnen-Unterhaltung mit diesem Kunden ist bereits beendet, daher wurde die Willkommensnachricht nicht gesendet.",
      "welcome_delivery_unknown": "Ein früherer Versand dieser Willkommensnachricht hat den Kunden möglicherweise bereits erreicht, daher wurde sie nicht erneut gesendet."
    },
    "confirmObject": {
      "cardTitleBooking": "Buchung bestätigen",
      "cardTitleCancel": "Stornierung bestätigen",
      "cardTitleRebook": "Stornieren und buchen",
      "cardTitleIdentity": "Identität bestätigen",
      "customerLabel": "Kunde",
      "classLabel": "Kurs",
      "classIdLabel": "Kurs-ID",
      "dateLabel": "Datum",
      "timeLabel": "Uhrzeit",
      "instructorLabel": "Trainer",
      "bookingRefLabel": "Buchungsnr.",
      "rebookFromLabel": "Stornieren",
      "rebookToLabel": "Buchen",
      "cancelSetAnd": "und",
      "cancelSetUnknownClass": "Ein Kurs (Details nicht verfügbar)",
      "contactLabel": "Kontakt",
      "contactMissing": "Keine E-Mail, Telefonnummer oder Instagram-Handle in diesem Chat.",
      "itineraryPartial": "Kursname, Datum und Ortszeit sind in dieser Nutzlast noch nicht enthalten. Bestätigen führt die freigegebene Schreibaktion trotzdem aus.",
      "confirmBooking": "Buchung bestätigen",
      "confirmCancellation": "Stornierung bestätigen",
      "confirmRebook": "Stornieren und buchen bestätigen",
      "confirmIdentity": "Identität bestätigen",
      "abort": "Abbrechen",
      "abortUnavailable": "Verwerfen ist noch nicht verfügbar. Bestätigen führt trotzdem aus; das Ausblenden dieser Karte bricht die ausstehende Schreibaktion nicht ab.",
      "bookingInProgress": "Buchung läuft…",
      "bookingStillRunning": "Die Buchung läuft noch. Sie können in anderen Chats weiterarbeiten; das Ergebnis erscheint hier.",
      "abortIdentityHint": "Bestätigt die Identität nicht. Es wird keine Anfrage gesendet.",
      "claimLive": "{{name}} schließt das gerade ab. Bestätigen und Abbrechen sind vorübergehend gesperrt.",
      "claimLiveNoName": "Eine andere Managerin oder ein anderer Manager schließt das gerade ab. Bestätigen und Abbrechen sind vorübergehend gesperrt.",
      "claimStale": "Der letzte Versuch wurde nicht abgeschlossen. Sie können es erneut versuchen."
    },
    "groupBooking": {
      "listBadgeAria": "Gruppen- oder Teamanfrage",
      "listTooltip": "Diese Konversation hat einen ausstehenden Entwurf für eine gruppen- oder teamförmige Buchungsanfrage.",
      "draftCardTitle": "Gruppen- / Teamanfrage",
      "cardTitle": "Gruppen- / Teamanfrage",
      "extractedPartySize": "Notierte Gruppengröße: {{count}}",
      "partySize": "Notierte Gruppengröße: {{count}}",
      "participantsLabel": "Teilnehmer",
      "checklistLabel": "Checkliste für Manager",
      "checklistUnknown": "Punkt: {{key}}",
      "overrideReasonUnknown": "{{key}}",
      "status": {
        "collecting": "Teilnehmerliste wird erfasst",
        "awaitingManager": "Wartet auf Prüfung durch Manager",
        "awaitingApproval": "Wartet auf Ihre Freigabe",
        "running": "Automatisierung läuft",
        "done": "Abgeschlossen",
        "failed": "Automatisierung fehlgeschlagen",
        "manualFallback": "Manuelle Bearbeitung erforderlich",
        "notApplicable": "Nicht zutreffend"
      },
      "checklist": {
        "party_size": "Endgültige Teilnehmerzahl und Altersaufteilung klären",
        "date_window": "Bevorzugte Daten oder Zeitfenster bestätigen",
        "offering_type": "Kurstyp, Paket oder Private-Hire-Umfang bestätigen",
        "deposit_or_po": "Anzahlung, Bestellung (PO) oder Rechnungskontakt falls zutreffend",
        "bill_to": "Rechnungsempfänger und Steuerangaben falls erforderlich",
        "roster_complete": "Teilnehmerliste vollständig bestätigen (Namen und Kontakte)",
        "class_slot": "Kurs, Termin oder Zeitfenster bestätigen",
        "book_without_product": "Buchung ohne verknüpftes Produkt erfassen, falls nötig",
        "invoice_externally": "Außerhalb der Plattform abrechnen oder fakturieren, falls erforderlich",
        "terms_confirm_on_site": "Bedingungen und Richtlinien vor Ort bestätigen, falls nötig"
      },
      "overrideReason": {
        "group_policy_overrode_auto_send": "Automatisches Senden wurde für diese Runde durch Ihre Gruppen-/Teamrichtlinie überschrieben — bitte vor dem Versand prüfen."
      }
    },
    "escalateModalTitle": "Konversation eskalieren",
    "escalateModalBody": "Das Team wird für manuelle Nachbearbeitung benachrichtigt.",
    "resolvedModalTitle": "Als erledigt markieren",
    "resolvedModalBody": "Diese Konversation wird als erledigt markiert.",
    "filter": {
      "panelTitle": "Filter",
      "panelDescription": "Filter für die Konversationsliste wählen und anwenden.",
      "closeAria": "Filter schließen",
      "sectionStatus": "STATUS",
      "sectionIntention": "ABSICHT",
      "sectionCustomerId": "KUNDEN-ID",
      "sectionChannel": "KANAL",
      "statusUnread": "Ungelesen",
      "statusNeedsReview": "Prüfung nötig",
      "statusEscalated": "Eskaliert",
      "statusAiHandled": "KI bearbeitet",
      "statusResolved": "Erledigt",
      "statusNeedsFollowup": "Nachfassung nötig"
    },
    "sort": {
      "newest": "Neueste zuerst",
      "oldest": "Älteste zuerst",
      "unreadFirst": "Ungelesene zuerst",
      "escalatedFirst": "Eskalierte zuerst",
      "sessionExpiringFirst": "Session-Dringlichkeit",
      "byStatus": "Nach Status"
    },
    "intentChip": {
      "newBooking": "Neue Buchung",
      "rebooking": "Umbuchung",
      "cancellation": "Stornierung",
      "generalInfo": "Allgemeine Infos",
      "schedule": "Termin",
      "membership": "Mitgliedschaft",
      "other": "Sonstiges"
    },
    "customerId": {
      "identified": "Identifiziert",
      "idPending": "ID ausstehend",
      "unmatched": "Kein Treffer",
      "generalInquiry": "Allgemeine Anfrage"
    },
    "leadBadge": {
      "label": "Lead"
    },
    "channel": {
      "instagram": "Instagram",
      "whatsapp": "WhatsApp",
      "facebook": "Facebook Messenger",
      "email": "E-Mail"
    },
    "email": {
      "from": "Von",
      "to": "An",
      "cc": "Cc",
      "authorCustomer": "Kunde",
      "subject": "Betreff",
      "sendFromMailbox": "Antworten werden von {{mailbox}} gesendet",
      "emptyConnectHint": "Verbinden Sie E-Mail unter Einstellungen → Kanäle oder in der Kopfzeile, um Threads hier zu sehen.",
      "deliveryFailed": "Zustellung fehlgeschlagen",
      "showPreviousMessages": "Frühere Nachrichten anzeigen",
      "hidePreviousMessages": "Frühere Nachrichten ausblenden",
      "inlineImageUnavailable": "Inline-Bild nicht verfügbar",
      "attachmentDownloadFailed": "Anhang konnte nicht heruntergeladen werden",
      "grantExpiredBannerTitle": "E-Mail erneut verbinden erforderlich",
      "grantExpiredBannerBody": "Senden ist deaktiviert, bis Sie das Postfach erneut verbinden.",
      "grantExpiredBannerCta": "Einstellungen → Kanäle öffnen",
      "grantExpiredComposer": "Verbinden Sie E-Mail in den Einstellungen erneut, um Nachrichten zu senden.",
      "composer": {
        "send": "Senden",
        "replyAll": "Allen antworten",
        "bold": "Fett",
        "italic": "Kursiv",
        "underline": "Unterstrichen",
        "bulletList": "Aufzählung",
        "numberedList": "Nummerierte Liste",
        "link": "Link einfügen",
        "insertImage": "Bild einfügen",
        "attachFile": "Datei anhängen",
        "bodyAria": "E-Mail-Nachrichtentext",
        "linkPrompt": "Link-URL eingeben",
        "linkUrlInvalid": "Geben Sie eine gültige Webadresse ein (z. B. example.com)",
        "imageTypeError": "Wählen Sie eine Bilddatei",
        "attachmentMaxCount": "Maximal {{count}} Anhänge",
        "attachmentOversize": "Anhang ist zu groß",
        "attachmentUploadFailed": "Anhang konnte nicht hochgeladen werden",
        "attachmentRemoveFailed": "Anhang konnte nicht entfernt werden",
        "inlineImageNotReady": "Das eingebettete Bild ist noch nicht sendebereit. Warten Sie, falls ein Upload läuft, oder entfernen Sie das Bild und versuchen Sie es erneut.",
        "removeAttachment": "{{name}} entfernen",
        "bodyCharCount": "{{count}} / {{max}} Zeichen"
      }
    },
    "provenance": {
      "autoAi": "Auto-KI",
      "approvedAi": "Freigegebene KI",
      "team": "Team",
      "sessionNudge": "OktoGo — Session-Nudge"
    },
    "infoRow": {
      "phone": "Telefon",
      "instagram": "Instagram",
      "email": "E-Mail"
    },
    "handling": {
      "autoSendAll": "Alle Themen: automatisch senden",
      "autoSendNone": "Alle Themen: Entwurf zur Freigabe",
      "autoSendMixed": "Gemischt: teils automatisch, teils Freigabe",
      "teamStyleOn": "Team-Stil an",
      "teamStyleOff": "Team-Stil aus",
      "autoLabelPrefix": "Auto-Label: {{label}}",
      "tooltip": "So bearbeitet die KI diesen Thread in OktoGo. Die Zustellung läuft weiter über Ihr verbundenes WhatsApp- oder Instagram-Business-Konto."
    },
    "archiveChatError": "Chat konnte nicht archiviert werden",
    "archiveChatSuccess": "Chat archiviert",
    "archiveDialogTitle": "Chat archivieren",
    "archiveDialogBody": "Möchten Sie diesen Chat wirklich archivieren?",
    "archiveDangerTitle": "Gefahrenzone",
    "archiveDangerBody": "Diese Aktion ist in der App nicht rückgängig zu machen. Die Konversation wird aus Ihrer Chatliste entfernt und Teammitglieder sehen sie hier nicht mehr. Der Nachrichtenverlauf kann zu Compliance-Zwecken aufbewahrt werden, ist in dieser Oberfläche aber ggf. nicht mehr verfügbar.",
    "archiveAnyway": "Trotzdem archivieren",
    "customerWroteAgain": {
      "notice": "Der Kunde hat noch einmal geschrieben. Diese Bestätigung gilt nicht mehr. Der Assistent liest die neue Nachricht."
    },
    "saveEdit": "Speichern",
    "messageEdited": "bearbeitet",
    "attachmentPhotoVideo": "Foto / Video",
    "attachmentDocument": "Dokument",
    "attachmentUpload": "Datei hochladen",
    "richCards": {
      "availabilitySpots": "{{spots}} Plätze",
      "availabilitySpotsWarning": "{{spots}} Plätze ⚠️",
      "bookingNoFee": "Keine Gebühr erhoben",
      "bookingNewClient": "Neues Kundenkonto erstellt",
      "bookingConfirmedTitle": "Buchung bestätigt",
      "bookingCreditsLine": "Credits genutzt: {{used}} · Verbleibend: {{remaining}}",
      "rebookingCancelled": "Storniert",
      "rebookingRebooked": "Umgebucht",
      "policyRequiredNotice": "Erforderliche Frist: {{value}}",
      "policyTimeUntilClass": "Zeit bis zum Kurs: {{value}}",
      "policyLateFee": "Verspätungsgebühr: {{value}}",
      "scheduleStatusOpen": "Offen",
      "multiBookedTitle": "{{count}} Kurse gebucht",
      "membershipLabel": "Mitgliedschaft: {{name}}",
      "membershipUsedProgress": "{{used}} / {{total}} genutzt",
      "membershipRemaining": "Verbleibend: {{remaining}}",
      "membershipExpires": "Läuft ab: {{date}} ({{days}} Tage)",
      "membershipBookNext": "Nächsten Kurs buchen",
      "membershipRenew": "Verlängern — {{label}} {{price}}"
    },
    "customerPanel": {
      "noListingChannel": "Kein Listing-Kanal verbunden",
      "noBookingPlatform": "Keine Buchungsplattform verbunden",
      "memberCustomerId": "Mitglieds- / Kunden-ID",
      "secondaryReference": "Sekundäre Referenz",
      "noMatchingGuest": "Kein passender Gastdatensatz",
      "noMatchingCustomer": "Kein passender Kundendatensatz",
      "joinedLineStr": "{{line}} · {{platform}}",
      "guestNotFoundIn": "Gast nicht in {{platform}} gefunden",
      "connectedPlatform": "Verbunden · {{platform}}",
      "eversportsCustomerId": "Eversports-Kunden-ID",
      "genericCustomerId": "{{platform}}-Kunden-ID",
      "mindbodyClientId": "Mindbody-Client-ID",
      "bsportMemberId": "Bsport-Mitglieds-ID",
      "partnerNetworkId": "Partner- / Netzwerk-ID",
      "customerNotFoundIn": "Kunde nicht in {{platform}} gefunden"
    },
    "noMessages": "Keine Nachrichten.",
    "draftApproveSend": "Senden",
    "identityPendingHint": "Identität ausstehend —",
    "identityApprovalSuccess": "Identität bestätigt. Sie können den Entwurf jetzt freigeben und senden.",
    "identityVerifiedMilestone": "Identität bestätigt",
    "identityApprovalFailed": "Identität konnte nicht bestätigt werden. Bitte versuchen Sie es gleich erneut.",
    "identityApprovalNotAvailable": "Noch kein verknüpftes Kundenprofil. Warten Sie auf die Bestätigung der Kundin/des Kunden oder verknüpfen Sie zuerst ein Profil und versuchen Sie es dann erneut.",
    "identityInvalidState": "Für dieses Gespräch steht keine Identitätsfreigabe aus. Aktualisieren Sie die Ansicht und versuchen Sie es erneut.",
    "draftEdit": "Bearbeiten",
    "draftDeliveredDiffers": "Der gesendete Text weicht vom freigegebenen Entwurf ab.",
    "draftRegenerate": "Neu generieren",
    "draftAbortFailed": "Die ausstehende Aktion konnte nicht verworfen werden. Bitte versuchen Sie es gleich erneut.",
    "reject": "Ablehnen",
    "reportIssue": "Problem melden",
    "reportCopilotIssueMenu": "Copilot-Problem melden",
    "feedback": {
      "dialogTitleReject": "Vorgeschlagene Antwort ablehnen",
      "dialogTitleReport": "Copilot-Problem melden",
      "dialogDescriptionReject": "Sagen Sie uns, was schiefgelaufen ist. Die vorgeschlagene Antwort wird nach dem Absenden entfernt.",
      "dialogDescriptionReport": "Beschreiben Sie das Problem. Ihre vorgeschlagene Antwort bleibt erhalten, damit Sie sie weiter bearbeiten oder senden können.",
      "categoryLegend": "Was war das Problem?",
      "categoryRequired": "Bitte wählen Sie eine Kategorie.",
      "category": {
        "wrongInformation": "Falsche oder veraltete Information",
        "wrongTone": "Falscher Ton oder Formulierung",
        "shouldHaveAsked": "Hätte mich zuerst fragen sollen",
        "bookingMistake": "Buchungsfehler",
        "misunderstood": "Anfrage missverstanden",
        "other": "Sonstiges"
      },
      "detailsLabel": "Details (optional)",
      "detailsPlaceholder": "Was hätte Copilot anders machen sollen?",
      "includeContext": "Gesprächskontext mitsenden",
      "piiWarning": "Keine Screenshots mit Telefonnummern oder Zahlungsdaten von Kunden anhängen.",
      "wrongInformationHint": "Studio-Fakten können Sie in",
      "studioDataLink": "Studio-Daten",
      "cancel": "Abbrechen",
      "submitReject": "Ablehnen",
      "submitReport": "Meldung senden",
      "submitting": "Wird gesendet…",
      "submitThanks": "Danke — Ihr Feedback hilft uns, Copilot zu verbessern.",
      "errorGeneric": "Feedback konnte nicht gesendet werden. Bitte erneut versuchen.",
      "errorNoPendingDraft": "Es gibt keinen ausstehenden Entwurf zum Ablehnen.",
      "errorRateLimited": "Sie haben kürzlich mehrere Meldungen gesendet. Bitte warten Sie einige Minuten.",
      "errorForbidden": "Sie haben keine Berechtigung, Feedback für diesen Chat zu senden.",
      "reportedDraftLabel": "Gemeldete vorgeschlagene Antwort",
      "errorAttachmentUpload": "Das Bild konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.",
      "errorUnsupportedFileType": "Nicht unterstützter Dateityp",
      "attachmentsLabel": "Screenshots (optional)",
      "addAttachment": "Bild hinzufügen",
      "attachmentOversize": "Jedes Bild darf höchstens 2 MB groß sein.",
      "attachmentMaxCount": "Sie können bis zu 3 Bilder anhängen.",
      "attachmentsDropHint": "Bilder hier einfügen oder ablegen (PNG, JPEG, WebP; max. 2 MB pro Bild).",
      "scenarioSuggestedLegend": "Testszenario (Vorschlag)",
      "scenarioConfidence": "Konfidenz: {{level}}",
      "scenarioConfidenceHigh": "Hoch",
      "scenarioConfidenceMedium": "Mittel",
      "scenarioConfidenceLow": "Niedrig",
      "scenarioChange": "Ändern",
      "scenarioSkipMapping": "Unsicher / Zuordnung überspringen",
      "scenarioNoSuggestion": "Keine automatische Zuordnung für diese Kategorie. Manuell wählen oder überspringen.",
      "scenarioPickManual": "Szenario wählen"
    },
    "whatsappTemplatePicker": {
      "title": "Genehmigte Vorlage auswählen",
      "aria": "Genehmigte Vorlage auswählen",
      "searchPlaceholder": "Nachrichtenvorlagen suchen…",
      "select": "Auswählen",
      "insert": "Einfügen",
      "inWindowHint": "Der Vorlagentext wird in Ihren Entwurf eingefügt. Senden Sie ihn wie gewohnt mit Freigeben und senden."
    },
    "whatsappTemplate": {
      "panelTitle": "Nachrichtenvorlage",
      "panelSubtitle": "Außerhalb des 24-Stunden-Fensters erreichen nur von Meta genehmigte Vorlagen die Kundin oder den Kunden.",
      "loading": "Vorlagen werden geladen…",
      "loadError": "WhatsApp-Vorlagen konnten nicht geladen werden.",
      "retry": "Erneut versuchen",
      "emptyApproved": "Keine genehmigten Vorlagen für dieses Studio. Fügen Sie Vorlagen unter Einstellungen → Kanäle hinzu oder lassen Sie sie genehmigen.",
      "templateLabel": "Vorlage",
      "templatePlaceholder": "Vorlage wählen",
      "variableLabel": "Variable {{index}}",
      "variableCountError": "Diese Vorlage benötigt {{count}} Variable(n).",
      "previewLabel": "Vorschau",
      "sendButton": "Vorlage senden",
      "sendSuccess": "Vorlagennachricht wurde in die Warteschlange gestellt.",
      "sendError": "Vorlage konnte nicht gesendet werden. Bitte erneut versuchen.",
      "approveBlockedTooltip": "Freiform-Freigabe ist blockiert. Senden Sie unten eine genehmigte WhatsApp-Vorlage.",
      "suggestedLabel": "Für diesen Thread vorgeschlagen",
      "llmSuggestedHelper": "Von KI für diesen Thread vorgeschlagen.",
      "suggestionRationale": {
        "supportFollowup": "Nachfassen zu einer kürzlichen Kundennachricht",
        "aiHandoff": "Übergabe an ein Teammitglied nach Eskalation",
        "bookingCancelled": "Kontext: Buchungsstornierung",
        "classReminder": "Kurs- oder Buchungserinnerung",
        "bookingConfirmed": "Buchungsbestätigung",
        "waitlist": "Wartelistenplatz verfügbar",
        "reengagement": "Erneut ansprechen nach Abschluss"
      }
    },
    "insertMessage": {
      "chooseTemplate": "Nachrichtenvorlage wählen"
    },
    "messageTemplate": {
      "panelTitle": "Nachrichtenvorlage",
      "expiredEmptyTitle": "Messaging-Fenster geschlossen",
      "expiredEmptyBody": "Wählen Sie eine genehmigte WhatsApp-Nachrichtenvorlage, um diese Kundin oder diesen Kunden zu erreichen.",
      "editVariables": "Variablen bearbeiten"
    },
    "feedbackEditor": {
      "bold": "Fett",
      "italic": "Kursiv",
      "bulletList": "Aufzählung",
      "orderedList": "Nummerierte Liste",
      "emoji": "Emoji einfügen",
      "markdownHint": "Die Formatierung verwendet Markdown. Mit „Vorschau“ sehen Sie die Darstellung.",
      "showPreview": "Vorschau",
      "hidePreview": "Bearbeiten"
    },
    "draftRegenerateTitle": "Neu generieren",
    "draftAiDraft": "Vorgeschlagene Antwort",
    "draftReviewing": "Vorgeschlagene Antwort — in Prüfung",
    "draftReview": "Prüfen",
    "composeManualReply": "Manuelle Antwort",
    "composeManualReplyPlaceholder": "Nachricht manuell eingeben",
    "draftSave": "Entwurf speichern",
    "draftRegenerateFailed": "Neu-Generierung fehlgeschlagen.",
    "draftRegenerateFailedRetry": "Neu-Generierung fehlgeschlagen. Bitte erneut versuchen.",
    "draftRegenerateWsFailed": "Neu-Generierung des Entwurfs fehlgeschlagen.",
    "replySendFailed": "Wir konnten Ihre Nachricht nicht senden – sie steht wieder im Eingabefeld für Sie bereit. Bitte versuchen Sie es gleich noch einmal.",
    "replyTooLong": "Diese Nachricht ist zu lang zum Senden. Kürzen Sie sie oder hängen Sie den Text als Datei an.",
    "replyTooLongDelta": "Diese Nachricht ist {{over}} Zeichen zu lang zum Senden. Kürzen Sie sie oder hängen Sie den Text als Datei an.",
    "actionLogExpand": "KI-Aktionsprotokoll ausklappen",
    "actionLogCollapse": "KI-Aktionsprotokoll einklappen",
    "actionLogTitle": "KI-Aktionsprotokoll",
    "actionLogCountOne": "{{count}} Aktion",
    "actionLogCountOther": "{{count}} Aktionen",
    "actionLogAttribution": "von {{name}}",
    "actionLogLabels": {
      "draft_approved": "Entwurf freigegeben und gesendet",
      "draft_edited": "Entwurf bearbeitet",
      "draft_edited_and_sent": "Entwurf bearbeitet und gesendet",
      "draft_regenerated": "Entwurf neu erstellt",
      "draft_aborted": "Entwurf vor dem Senden abgebrochen",
      "manual_reply_sent": "Manuelle Antwort gesendet",
      "whatsapp_template_sent": "WhatsApp-Vorlage gesendet",
      "auto_reply_sent": "Automatische Antwort gesendet",
      "status_changed": "Status geändert",
      "identity_approved": "Identität bestätigt",
      "faq_created": "FAQ erstellt",
      "faq_edited": "FAQ bearbeitet",
      "faq_deleted": "FAQ gelöscht",
      "toggle_changed": "Einstellung geändert",
      "menu_answered": "Menü beantwortet"
    },
    "registrationTitle": "Anmeldung",
    "registrationSendLink": "Anmeldelink senden",
    "registrationAssisted": "Unterstützte Anmeldung",
    "registrationSendLinkButton": "Link senden",
    "refundApplicable": "Noch rechtzeitig — das Kursguthaben oder der Pass sollte zurückkommen.",
    "refundNotApplicable": "Zu kurz vor Kursbeginn — es kommt kein Kursguthaben zurück."
  },
  "archive": {
    "permissionToast": "Sie haben keine Berechtigung für das Archiv.",
    "restoreError": "Wiederherstellung fehlgeschlagen",
    "studioLimitReached": "Maximal 5 aktive Studios. Archivieren Sie eines, bevor Sie dieses Studio wiederherstellen.",
    "conversationRestored": "Konversation wiederhergestellt",
    "studioRestored": "Studio wiederhergestellt",
    "deleteError": "Löschen fehlgeschlagen",
    "deleteBlockedFeedback": "Diese Konversation hat KI-Feedback und kann nicht endgültig gelöscht werden. Sie bleibt archiviert.",
    "conversationDeleted": "Konversation endgültig gelöscht",
    "studioDeleted": "Studio endgültig gelöscht",
    "loadError": "Archiv konnte nicht geladen werden.",
    "empty": "Noch keine archivierten Einträge",
    "noFilterResults": "Keine Treffer für die aktuellen Filter.",
    "columnName": "Name",
    "columnType": "Typ",
    "columnStudio": "Studio",
    "columnArchived": "Archiviert",
    "columnActions": "Aktionen",
    "channelTitle": "Kanal",
    "channelWhatsapp": "WhatsApp",
    "channelInstagram": "Instagram",
    "channelUnknown": "—",
    "restore": "Wiederherstellen",
    "deleteForever": "Endgültig löschen",
    "purgeTitle": "Endgültig löschen",
    "purgeBodyConversation": "Diese archivierte Konversation ({{name}}) endgültig löschen? Dies kann nicht rückgängig gemacht werden.",
    "purgeBodyStudio": "Dieses archivierte Studio ({{name}}) endgültig löschen? Dies kann nicht rückgängig gemacht werden.",
    "purgeDangerConversation": "Alle Nachrichten und Metadaten dieser Konversation werden aus der Datenbank entfernt.",
    "purgeDangerStudio": "Das Studio und zugehörige Daten werden dauerhaft aus der Datenbank entfernt.",
    "loadMore": "Mehr laden",
    "purgeConversationTitle": "Konversation endgültig löschen?",
    "purgeConversationBody": "Entfernt den archivierten Chat dauerhaft. Dies kann nicht rückgängig gemacht werden.",
    "purgeStudioTitle": "Studio endgültig löschen?",
    "purgeStudioBody": "Geben Sie den Studionamen zur Bestätigung ein.",
    "searchAria": "Archiv nach Namen durchsuchen",
    "filter": {
      "panelTitle": "Filter",
      "panelDescription": "Archivierte Chats und Studios nach Typ, Studio und Archivierungszeit filtern.",
      "filterArchiveAria": "Archiv filtern",
      "sectionType": "Typ",
      "sectionStudio": "Studio",
      "sectionArchivedAgo": "Archiviert vor",
      "typeAll": "Alle",
      "typeChat": "Chat",
      "typeStudio": "Studio",
      "allStudios": "Alle Studios",
      "filterByStudioAria": "Nach Studio filtern",
      "tagTypeChat": "Typ: Chat",
      "tagTypeStudio": "Typ: Studio",
      "tagStudio": "Studio: {{name}}",
      "tagArchived": "Archiviert: {{label}}",
      "studioFallback": "Studio"
    },
    "time": {
      "all": "Alle Daten",
      "today": "Heute",
      "yesterday": "Gestern",
      "this_week": "Diese Woche",
      "last_week": "Letzte Woche",
      "this_month": "Dieser Monat",
      "last_month": "Letzter Monat",
      "this_year": "Dieses Jahr"
    },
    "rowType": {
      "conversation": "Chat",
      "studio": "Studio"
    }
  },
  "notFound": {
    "code": "404",
    "title": "Seite nicht gefunden",
    "home": "Zur Startseite"
  },
  "setupNotComplete": {
    "title": "Studio-Einrichtung nicht abgeschlossen",
    "body": "Der Studioinhaber hat die Einrichtung noch nicht abgeschlossen. Sie erhalten Zugang, sobald die Einrichtung fertig ist."
  },
  "routeErrorBoundary": {
    "summary": "Diese Seite konnte nicht geladen werden. Bitte laden Sie sie erneut.",
    "reload": "Seite neu laden"
  },
  "studio": {
    "scopeAllStudiosRejected": "„Alle Studios“ ist für Ihr Konto nicht verfügbar. Es wurde ein einzelnes Studio ausgewählt.",
    "scopeSwitchFailed": "Studio-Kontext konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut."
  },
  "vertical": {
    "fitness": {
      "dataSectionNavLabel": "Studio-Daten",
      "dataSectionPageTitle": "Studio-Daten",
      "dataSectionReadOnlyNoun": "Studio-Daten",
      "dataSectionAddUnitExpandedLabel": "Neues Studio hinzufügen",
      "dataSectionListColumnTitle": "Studios",
      "dataSectionMobileDescription": "Verwalten Sie Studio-Infos, FAQs, Richtlinien und den Kursplan.",
      "aggregateScopeLabel": "Alle Studios",
      "selectScopeActionLabel": "Studio wählen",
      "overlaySelectScopeMessage": "Wechseln Sie zu einem bestimmten Studio, um Einstellungen zu bearbeiten.",
      "teamInviteUnitsMulti": "Studios (eins oder mehrere wählen)",
      "teamInviteUnitsSingle": "Studio",
      "teamInviteNoUnitsAvailable": "Für Ihr Konto sind keine Studios für Einladungen verfügbar.",
      "teamInviteSelectAtLeastOne": "Wählen Sie mindestens ein Studio.",
      "chatsConversationUnitLabel": "Studio",
      "chatsIdentificationMatchingCopy": "Wir ordnen diesen Kontakt einem Studio-Mitglied zu. Das kann einen Moment dauern.",
      "agentTraceSelectScopeMessage": "Wählen Sie ein Studio, um Traces zu laden.",
      "agentTraceLoadErrorNeedsScope": "Wählen Sie ein Studio und geben Sie eine gültige Agent-Run-UUID ein.",
      "agentTraceNoAuditEventsForUnit": "Keine Audit-Ereignisse in diesem Zeitfenster für dieses Studio.",
      "aiSettingsContactOwnerReadOnly": "Wenden Sie sich an den Studioinhaber, um KI-Einstellungen zu ändern.",
      "onboardingBookingConnectTitle": "Buchungsplattform verbinden",
      "onboardingBookingConnectSubtitle": "Verbinden Sie Ihre Buchungsplattform, um Kurse, Pläne und Mitgliedschaften zu synchronisieren.",
      "onboardingBookingUsernamePlaceholder": "sie@studio.com",
      "dashboardStatConversationsToday": "Konversationen heute",
      "dashboardStatHandledByAiPct": "Von KI bearbeitet %",
      "dashboardStatBookingsMade": "Buchungen getätigt",
      "dashboardStatAvgFirstResponse": "Ø erste Antwort",
      "chatsMockJoinedBookingLine": "Eversports beigetreten",
      "chatsMockMembershipHeading": "Mitgliedschaft",
      "chatsMockScheduleHeading": "Kurse",
      "chatsCustomerPanelPlatformsHeading": "Plattformen",
      "chatsCustomerPanelAggregatorLabel": "Aggregator",
      "chatsCustomerPanelNetworkLabel": "Netzwerk",
      "chatsCustomerPanelPrimaryPlatformIdLabel": "Eversports-Kunden-ID",
      "chatsCustomerPanelSecondaryPlatformIdLabel": "myClubs-Mitglieds-ID",
      "chatsCustomerPanelAggregatorIdLabel": "Aggregator-ID",
      "chatsCustomerPanelCustomerRecordIdLabel": "Kunden-ID",
      "chatsCustomerPanelConversationRefLabel": "Konversation",
      "chatsUnmatchedNotFoundTitle": "Kunde nicht in Eversports gefunden",
      "chatsUnmatchedNotFoundBody": "Dieser Kontakt passt zu keinem bekannten Mitglied. Manuelle Suche kann nötig sein.",
      "chatsIdentificationInProgressTitle": "Kundenidentifikation läuft",
      "chatsNoMembershipRecordTitle": "Kein Mitgliedschaftsdatensatz",
      "chatsNoMembershipRecordBody": "Das wirkt wie eine allgemeine Anfrage oder ein potenzielles neues Mitglied.",
      "visionAgentTraceButtonLabel": "Vision-Agent-Trace",
      "pageScopeDescription": "Übersicht, Konversationen und Studio-Daten unten folgen dem hier gewählten Studio. „Alle Studios“ für eine aggregierte Ansicht, wo verfügbar.",
      "connectionsTableUnitColumn": "Studio",
      "settingsAccountVerticalTitle": "Produkt-Branche",
      "settingsAccountVerticalHint": "Fitness behält Studio- und Kursbegriffe. Kurzzeitmiete wechselt Texte und Listing-Kanal-Optionen in einen Objektkontext."
    },
    "str": {
      "dataSectionNavLabel": "Objektdaten",
      "dataSectionPageTitle": "Objektdaten",
      "dataSectionReadOnlyNoun": "Objektdaten",
      "dataSectionAddUnitExpandedLabel": "Neues Objekt hinzufügen",
      "dataSectionListColumnTitle": "Objekte",
      "dataSectionMobileDescription": "Verwalten Sie Objektinfos, FAQs, Richtlinien und gästerelevante Details.",
      "aggregateScopeLabel": "Alle Objekte",
      "selectScopeActionLabel": "Objekt wählen",
      "overlaySelectScopeMessage": "Wechseln Sie zu einem bestimmten Objekt, um Einstellungen zu bearbeiten.",
      "teamInviteUnitsMulti": "Objekte (eins oder mehrere wählen)",
      "teamInviteUnitsSingle": "Objekt",
      "teamInviteNoUnitsAvailable": "Für Ihr Konto sind keine Objekte für Einladungen verfügbar.",
      "teamInviteSelectAtLeastOne": "Wählen Sie mindestens ein Objekt.",
      "chatsConversationUnitLabel": "Objekt",
      "chatsIdentificationMatchingCopy": "Wir ordnen diesen Kontakt einem Gast oder einer Reservierung zu. Das kann einen Moment dauern.",
      "agentTraceSelectScopeMessage": "Wählen Sie ein Objekt, um Traces zu laden.",
      "agentTraceLoadErrorNeedsScope": "Wählen Sie ein Objekt und geben Sie eine gültige Agent-Run-UUID ein.",
      "agentTraceNoAuditEventsForUnit": "Keine Audit-Ereignisse in diesem Zeitfenster für dieses Objekt.",
      "aiSettingsContactOwnerReadOnly": "Wenden Sie sich an den Objektinhaber, um KI-Einstellungen zu ändern.",
      "onboardingBookingConnectTitle": "Listing-Kanal verbinden",
      "onboardingBookingConnectSubtitle": "Verbinden Sie Ihre Listing- oder Reservierungsplattform, um Verfügbarkeit, Buchungen und Gastdaten zu synchronisieren.",
      "onboardingBookingUsernamePlaceholder": "sie@beispiel.de",
      "dashboardStatConversationsToday": "Konversationen heute",
      "dashboardStatHandledByAiPct": "Von KI bearbeitet %",
      "dashboardStatBookingsMade": "Reservierungen bestätigt",
      "dashboardStatAvgFirstResponse": "Ø erste Antwort",
      "chatsMockJoinedBookingLine": "Primärer Buchungskanal",
      "chatsMockMembershipHeading": "Gastprogramm",
      "chatsMockScheduleHeading": "Anstehende Aufenthalte",
      "chatsCustomerPanelPlatformsHeading": "Kanäle",
      "chatsCustomerPanelAggregatorLabel": "Primärkanal",
      "chatsCustomerPanelNetworkLabel": "Partner",
      "chatsCustomerPanelPrimaryPlatformIdLabel": "Gast-ID",
      "chatsCustomerPanelSecondaryPlatformIdLabel": "Reservierungsreferenz",
      "chatsCustomerPanelAggregatorIdLabel": "Quellenreferenz",
      "chatsCustomerPanelCustomerRecordIdLabel": "Gastdatensatz-ID",
      "chatsCustomerPanelConversationRefLabel": "Konversation",
      "chatsUnmatchedNotFoundTitle": "Gast im Buchungssystem nicht gefunden",
      "chatsUnmatchedNotFoundBody": "Dieser Kontakt passt zu keinem bekannten Gast oder keiner Reservierung. Manuelle Suche kann nötig sein.",
      "chatsIdentificationInProgressTitle": "Gastidentifikation läuft",
      "chatsNoMembershipRecordTitle": "Keine Reservierung hinterlegt",
      "chatsNoMembershipRecordBody": "Das wirkt wie eine allgemeine Anfrage oder eine potenzielle neue Buchung.",
      "visionAgentTraceButtonLabel": "Vision-Agent-Trace",
      "pageScopeDescription": "Übersicht, Konversationen und Objektdaten unten folgen dem hier gewählten Objekt. „Alle Objekte“ für eine aggregierte Ansicht, wo verfügbar.",
      "connectionsTableUnitColumn": "Objekt",
      "settingsAccountVerticalTitle": "Produkt-Branche",
      "settingsAccountVerticalHint": "Kurzzeitmiete nutzt Objekt- und Gastbegriffe mit Listing-Kanal-Integrationen. Fitness nutzt Studio- und Kursbegriffe."
    }
  },
  "ai": {
    "readOnlyContactOwner": "Wenden Sie sich an den Studioinhaber, um KI-Einstellungen zu ändern.",
    "readOnlyContactOwnerStr": "Wenden Sie sich an den Objektinhaber, um KI-Einstellungen zu ändern.",
    "sectionReplies": "Antworten nach Thema",
    "regimeLockedBanner": "Während des Pilotbetriebs bleibt Auto-Senden für alle Themen aus. Kontaktieren Sie OktoGo, um den Auto/Manuell-Schalter freizuschalten.",
    "toastRegimeLocked": "Auto-Senden ist für dieses Pilotstudio gesperrt. Kontaktieren Sie OktoGo zur Freischaltung.",
    "sectionTone": "Gesprächston",
    "sectionLearn": "Aus Team-Antworten lernen",
    "sectionAttribution": "Beschriftung für automatische KI-Antworten",
    "sectionEscalation": "Eskalationsregeln",
    "sectionEscalationHint": "Wann eine Konversation zur Prüfung markiert wird (weiche Eskalation). Die KI schreibt trotzdem einen Antwortentwurf — Sie geben ihn frei oder bearbeiten ihn vor dem Senden. Harte Übernahme — wenn ein Kunde einen Menschen verlangt oder die KI nicht sicher fertig werden kann — ist ein separates Sicherheitsnetz und wird hier nicht gesteuert.",
    "sectionSessionNudge": "Messaging-Session-Nudges",
    "sectionSessionNudgeHint": "Optionale kurze Kundennachricht vor Ablauf des WhatsApp-Freiformfensters. Läuft nur, wenn die Server-Automatisierung aktiv ist; ausstehende KI-Entwürfe überspringen den Versand.",
    "escalationStillDraftsNote": "Ob durch diese Regeln oder durch eine harte Sicherheits-Übergabe: Eskalierte Konversationen warten auf Ihre Freigabe — außer Identitätsbestätigungen, die immer gesendet werden, damit der Kunde beginnen kann. Die KI erstellt weiterhin Antwortvorschläge, damit Sie nie bei null anfangen müssen.",
    "save": "Speichern",
    "saving": "Wird gespeichert…",
    "saved": "KI-Einstellungen gespeichert.",
    "saveError": "KI-Einstellungen konnten nicht gespeichert werden.",
    "loadError": "KI-Einstellungen konnten nicht geladen werden.",
    "bookingRequiredTitle": "Zuerst Buchungsplattform verbinden",
    "bookingRequiredBody": "Automatisches Senden für Buchungsthemen funktioniert am besten mit verbundener Buchungsplattform unter Einstellungen → Kanäle.",
    "confirmEnableBooking": "Ohne verbundene Buchung aktivieren?",
    "enable": "Aktivieren",
    "useCase": {
      "booking": "Neue Buchung",
      "rebook": "Umbuchung",
      "cancel": "Stornierung",
      "info": "Allgemeine Infos",
      "schedule": "Terminanfrage",
      "trial": "Probe / Erstbesuch",
      "account": "Konto / Mitgliedschaft",
      "campaignLead": "Kampagnen-Lead"
    },
    "firstTrial": {
      "helper": {
        "title": "Probe / Erstbesuch — Copilot wählt den passenden Weg:",
        "scenario1": "Kein Konto auf der Buchungsplattform → Registrierungs- / Probelink",
        "scenario2": "Eversports-Konto vorhanden, neu in Ihrem Studio → Eversports-Studioseite; Buchungen bleiben Entwurf, bis die Person in Ihrem Studio verknüpft ist",
        "scenario2Booking": "Nach der Verknüpfung gelten die normalen Buchungsregeln (Zeile „Neue Buchung“)"
      },
      "readiness": {
        "title": "Bereitschaft für Erstprobetraining-Links",
        "precedenceNote": "Diese Links unter Studiodaten → Allgemein bearbeiten. Verbindungen zeigt nur die Bereitschaft.",
        "scenario1Ready": "Szenario 1 bereit: Registrierungs-/Testlink konfiguriert",
        "scenario1Missing": "Szenario 1: Registrierungs-/Testlink fehlt",
        "scenario2Ready": "Szenario 2 bereit: Eversports-Studioseite konfiguriert",
        "scenario2Missing": "Szenario 2: Eversports-Studioseite fehlt",
        "ctaStudioData": "Studio-Daten öffnen",
        "ctaConnections": "Connections öffnen"
      }
    },
    "tone": {
      "friendly": {
        "label": "Freundlich",
        "desc": "Warm, nahbar, mit Emojis. Startet mit du. Wechselt auf Sie, wenn Kunde oder Team klar förmlich schreiben."
      },
      "professional": {
        "label": "Formell",
        "desc": "Höflich, förmlich, keine Emojis. Startet mit der formellen Anrede (Sie). Wechselt auf du, wenn Kunde oder Team später klar du schreiben."
      },
      "casual": {
        "label": "Locker",
        "desc": "Locker und kurz. Startet mit du. Wechselt auf Sie, wenn Kunde oder Team klar förmlich schreiben."
      }
    },
    "repliesByTopicDesc": "Auto: Nach den Prüfungen und der Kundenbestätigung, wenn nötig (z. B. Umbuchung), darf die KI die Aktion ausführen und eine bestätigte Erfolgsmeldung senden. Manuell: Nach denselben Prüfungen und der Kundenbestätigung wartet die KI vor jeder Plattformänderung und vor der Erfolgsmeldung auf Ihre Freigabe.",
    "repliesByTopicManualWait": "Im Modus Manuell warten diese Themen auf Ihre Freigabe.",
    "repliesByTopicStillSentChip": "Trotzdem von allein: Identität bestätigen, schon im Kurs, später „erledigt“, später „bestätigt“ und einmal „soll ich stornieren?“ vor Ihrer Bestätigung. Sonst nichts.",
    "approveAllFirst": "Alle Nachrichten zuerst freigeben",
    "autoSendAllMessages": "Alle Nachrichten automatisch senden",
    "bookingUseCaseHint": "Unter Einstellungen → Kanäle verbinden, um mit Live-Termin- und Buchungsdaten zu arbeiten.",
    "toneSectionDesc": "Startstil für jedes Gespräch. Der Chat kann förmlicher oder lockerer werden, wenn Kunde oder Team später eine klare Anrede verwenden.",
    "learnSectionDesc": "Die KI übernimmt, wie Ihr Team schreibt — Länge, Wärme, Gruß. Ein klares Team-Sie oder -du reicht für den nächsten Vorschlag. Die letzte klare Anrede von Kunde oder Team gilt. Ohne klares Beispiel gilt weiter der Startstil oben.",
    "attributionSectionDesc": "Automatisch gesendete KI-Antworten erscheinen immer unter diesem Assistentennamen in Konversationen. Die Beschriftung lässt sich nicht abschalten. WhatsApp und Instagram nutzen weiter Ihr verbundenes Business-Konto — nicht diesen Namen.",
    "attributionDisplayNameLabel": "Anzeigename des Assistenten",
    "attributionDisplayNameHint": "Nur den Namen eingeben — AI wird automatisch angehängt und kann nicht entfernt werden. Beispiel: Kai → Kai AI. WhatsApp- und Instagram-Kunden sehen weiterhin Ihr verbundenes Business-Konto.",
    "attributionDisplayNameErrorEmpty": "Geben Sie einen Namen für den Assistenten ein.",
    "attributionDisplayNameErrorToken": "Geben Sie einen Namen für den Assistenten ein.",
    "attributionDisplayNameAiSuffixTitle": "AI wird immer nach dem Namen angehängt",
    "attributionDisplayNameAiSuffixSr": "AI ist fest nach dem Namen und nicht bearbeitbar.",
    "attributionDisplayNameSave": "Assistentennamen speichern",
    "attributionDisplayNameReset": "Auf Standard zurücksetzen",
    "attributionBackendPendingHint": "Speichern ist noch nicht möglich — der Server braucht noch die Assistentenname-API. Sie können den Namen hier entwerfen und prüfen.",
    "attributionStudio": "Studio-Name",
    "attributionAi": "KI-Assistent",
    "attributionLockedHint": "Nur Inhaber oder Manager können diese Einstellung ändern.",
    "toastAttributionSaved": "Anzeigename des Assistenten gespeichert.",
    "toastAttributionBackendNotReady": "Speichern noch nicht möglich — Assistentenanzeigename ist auf dem Server nicht verfügbar.",
    "escalateAfterPrefix": "Eskalieren nach",
    "escalateAfterSuffix": "fehlgeschlagenen Versuchen wird die Konversation zur Prüfung markiert.",
    "dialogEnableAutoSendTitle": "Automatisches Senden aktivieren",
    "dialogEnableAutoSendBody": "Nach den erforderlichen Prüfungen und der Kundenbestätigung, wenn der Ablauf sie verlangt (z. B. Umbuchung Storno+Neubuchung), darf die KI diese Aktion ausführen und eine bestätigte Erfolgsmeldung ohne Ihre Freigabe senden. Im manuellen Modus wartet sie vor jeder Plattformänderung und vor der Erfolgsmeldung auf Ihre Freigabe. Fortfahren?",
    "dialogAutoSendAllTitle": "Alle Nachrichten automatisch senden",
    "dialogAutoSendAllBody": "Bei Buchung, Umbuchung und Stornierung darf die KI erst nach den erforderlichen Prüfungen und der Kundenbestätigung handeln, wenn der Ablauf sie verlangt (Umbuchung = eine Bestätigung für Storno+Neubuchung zusammen). Im manuellen Modus wartet sie vor jeder Plattformänderung und vor der Erfolgsmeldung auf Ihre Freigabe.",
    "enableAll": "Alle aktivieren",
    "toastSettingSaveError": "Diese Einstellung konnte nicht gespeichert werden.",
    "toastAttributionError": "Beschriftungen für automatische Antworten konnten nicht aktualisiert werden.",
    "toastEscalationError": "Eskalationsregeln konnten nicht aktualisiert werden.",
    "sessionNudgeEnabled": "Automatischen Session-Nudge aktivieren",
    "sessionNudgeWhatsapp": "WhatsApp",
    "sessionNudgeInstagram": "Instagram (experimentell)",
    "sessionNudgeOnlyEscalated": "Nur bei Eskalation",
    "sessionNudgeMaxOne": "Höchstens ein Nudge pro Eskalation",
    "sessionNudgeWhenRemaining": "Senden, wenn verbleibende Zeit höchstens",
    "sessionNudgeHours4": "4 Stunden",
    "sessionNudgeHours6": "6 Stunden",
    "sessionNudgeHours8": "8 Stunden",
    "sessionNudgePreview": "Vorschau Standardnachricht",
    "sessionNudgePreviewMayDiffer": "Die tatsächliche Nachricht kann je nach Unterhaltung förmlicher oder informeller klingen, je nachdem, wie Ihr Team mit dem jeweiligen Kunden schreibt.",
    "toastSessionNudgeError": "Session-Nudge-Einstellungen konnten nicht gespeichert werden.",
    "toastAutoHandleError": "Auto-Bearbeitung konnte nicht aktualisiert werden.",
    "toastAutoHandleRateLimited": "Zu viele Änderungen auf einmal. Bitte versuchen Sie es gleich erneut.",
    "toastAutoHandleRateLimitedWithRetry": "Zu viele Änderungen auf einmal. Versuchen Sie es in etwa {{seconds}} Sekunden erneut.",
    "toastToneError": "Ton konnte nicht aktualisiert werden.",
    "toastGenericUpdateError": "Einstellungen konnten nicht aktualisiert werden.",
    "connectBookingFirst": "Verbinden Sie zuerst eine Buchungsplattform unter Einstellungen → Kanäle.",
    "connectListingFirst": "Verbinden Sie zuerst einen Listing-Kanal unter Einstellungen → Kanäle.",
    "campaignLeadNotReady": "Richten Sie zuerst eine startklare Kampagne unter Studio-Daten → Kampagnen ein, bevor Sie dies aktivieren.",
    "campaignLead": {
      "hintNoCampaign": "Noch keine Kampagne eingerichtet",
      "hintNotReady": "Kampagne noch nicht startklar",
      "hintEndDateMissing": "Der Kampagne fehlt ein Enddatum",
      "hintEndingSoon": "Kampagne endet am {{date}}",
      "hintExpired": "Letzte Kampagne ist abgelaufen",
      "hintSummaryActive": "{{count}} aktiv",
      "hintSummaryScheduled": "{{count}} geplant",
      "hintSummaryNotReady": "{{count}} nicht startklar",
      "hintSummaryExpired": "{{count}} abgelaufen",
      "ctaOpenCampaigns": "Kampagnen öffnen"
    },
    "groupBooking": {
      "sectionTitle": "Gruppenbuchungen",
      "sectionDesc": "Copilot erkennt Gruppen- und Firmenanfragen aus dem Gespräch und triagiert sie sicher, statt einzelne Plätze zu buchen.",
      "tabsAriaLabel": "Bereiche der Gruppenbuchungs-Einstellungen",
      "tabBasics": "Basis",
      "tabPolicies": "Richtlinien",
      "lockAria": "Nur für Inhaber",
      "enableLabel": "Gruppenbuchungen für dieses Studio aktivieren",
      "enableHint": "Wenn aktiv, erhalten gruppenförmige Gespräche einen Entwurf zur Freigabe und eine Manager-Checkliste statt eines automatischen Sendens.",
      "fulfillmentLabel": "Wie sollen Gruppenbuchungen behandelt werden?",
      "fulfillment": {
        "manual": "Manuell",
        "semiAutomated": "Teilautomatisch",
        "fullyAutomated": "Vollautomatisch",
        "manualDesc": "Copilot erstellt Antwortentwürfe und zeigt eine Roster-Checkliste; Sie buchen manuell im Buchungsplattform-Manager.",
        "semiAutomatedDesc": "Copilot erstellt Antwortentwürfe; nach Ihrer Freigabe kann er sichere Roster-Schritte im Buchungsplattform-Manager ausführen, sobald bereit.",
        "fullyAutomatedDesc": "Nur Pilot. Copilot kann sichere Roster-Schritte vor der Freigabe ausführen; Sie überwachen und greifen jederzeit ein.",
        "requiresConnection": "Teilautomatisch und Vollautomatisch erfordern eine verbundene Buchungsplattform. Verbinden Sie eine unter Einstellungen → Kanäle."
      },
      "maxPartyLabel": "Größte Gruppe, die Copilot automatisieren darf",
      "maxPartyHint": "Gilt nur für Teilautomatisch und Vollautomatisch. Größere Gruppen bleiben manuell. Bereich 2–50.",
      "escalationTargetLabel": "Bei Übergabe benachrichtigen",
      "escalationTargetHint": "Wer wird informiert, wenn eine Gruppenbuchung einen Menschen braucht. Zustellung: Chats während Sie in Copilot sind; Mobile-Push, wenn Sie nicht da sind (gemäß Konto → Benachrichtigungen).",
      "escalationTarget": {
        "owner": "Studio-Inhaber",
        "allChatMembers": "Alle Manager mit Chat-Zugriff"
      },
      "saveButton": "Gruppenbuchungs-Richtlinie speichern",
      "toastSaved": "Gruppenbuchungs-Richtlinie gespeichert.",
      "toastSaveError": "Gruppenbuchungs-Richtlinie konnte nicht gespeichert werden.",
      "toastEndpointUnavailable": "Die API für die Gruppenbuchungs-Richtlinie ist auf diesem Server noch nicht verfügbar. Die Einstellungen greifen, sobald Ihr Administrator das Backend-Update bereitstellt.",
      "toastLoadUnavailable": "KI-Einstellungen konnten nicht vom Server geladen werden.",
      "endpointUnavailableHint": "Speichern ist deaktiviert, bis die Richtlinien-Endpunkt-API verfügbar ist."
    },
    "escalation": {
      "no_match": "Keine Absicht erkannt",
      "sentiment": "Negative Stimmung erkannt",
      "repeat": "Kunde wiederholt Anfrage 3+ Mal",
      "explicit": "Kunde bittet um Menschen"
    }
  },
  "channelConnect": {
    "header": {
      "connectInstagram": "Instagram verbinden",
      "connectWhatsapp": "WhatsApp verbinden",
      "selectStudioTooltip": "Wählen Sie ein einzelnes Studio aus, um Kanäle zu verbinden"
    },
    "wizard": {
      "yes": "Ja",
      "no": "Nein",
      "continue": "Weiter",
      "back": "Zurück",
      "cancel": "Abbrechen",
      "retry": "Erneut versuchen",
      "learnMore": "Mehr erfahren",
      "instagram": {
        "title": "Instagram verbinden",
        "introBody": "Verbinden Sie Ihr Instagram-Profikonto, damit Oktogo Kundennachrichten in Chats verwalten kann.",
        "q1": "Haben Sie bereits ein Instagram-Profikonto (Business oder Creator)?",
        "q1Yes": "Ja, ich habe ein Profikonto",
        "q1No": "Nein, noch nicht",
        "q1HelpTitle": "Wechsel zum Profikonto",
        "q1Help": "Instagram öffnen → Einstellungen → Konto → Zu Profikonto wechseln, dann Business oder Creator wählen.",
        "q2": "Ist Ihr Instagram-Konto mit einer Facebook-Seite verknüpft?",
        "q2Yes": "Ja, mit einer Facebook-Seite verknüpft",
        "q2No": "Nein, noch nicht verknüpft",
        "q2HelpTitle": "Instagram mit Facebook-Seite verknüpfen",
        "q2Help": "Verknüpfen Sie in Meta Business Suite oder den Facebook-Seiteneinstellungen Ihr Instagram-Konto mit der Seite Ihres Studios.",
        "q3": "Ist der Zugriff auf Nachrichten für dieses Instagram-Konto aktiviert?",
        "q3Yes": "Ja, Nachrichtenzugriff ist aktiviert",
        "q3No": "Nein, noch nicht aktiviert",
        "q3HelpTitle": "Nachrichtenzugriff aktivieren",
        "q3Help": "In der Instagram-App: Einstellungen → Nachrichten → Nachrichtenkontrollen → Zugriff für verbundene Tools erlauben.",
        "confirm": "Instagram verbinden",
        "checkProfessional": "Instagram-Profikonto (Business oder Creator)",
        "checkFacebookPage": "Instagram mit Facebook-Seite verknüpft",
        "checkMessageAccess": "Nachrichtenzugriff aktiviert"
      },
      "whatsapp": {
        "title": "WhatsApp verbinden",
        "introBody": "Verbinden Sie WhatsApp Business, damit Oktogo Kundennachrichten in Chats verwalten kann.",
        "q1": "Haben Sie ein WhatsApp-Business-Konto (oder eine für die Business-API geeignete Nummer)?",
        "q1Yes": "Ja, ich habe WhatsApp Business",
        "q1No": "Nein, noch nicht",
        "q1HelpTitle": "WhatsApp Business einrichten",
        "q1Help": "Installieren Sie WhatsApp Business auf dem Studio-Telefon oder registrieren Sie eine Nummer bei Meta für die Business-API.",
        "q2": "Können Sie sich mit dem Meta-Konto anmelden, das dieses Unternehmen verwaltet?",
        "q2Yes": "Ja, ich habe Meta-Admin-Zugriff",
        "q2No": "Nein, ich habe keinen Admin-Zugriff",
        "q2HelpTitle": "Meta-Unternehmens-Admin-Zugriff",
        "q2Help": "Sie benötigen Admin-Zugriff auf das Meta-Unternehmenskonto, dem das WhatsApp-Business-Profil gehört.",
        "confirm": "WhatsApp verbinden",
        "checkBusiness": "WhatsApp-Business-Konto bereit",
        "checkMetaAccess": "Meta-Admin-Zugriff bestätigt"
      }
    },
    "oauth": {
      "successInstagram": "Instagram verbunden",
      "successInstagramHandle": "Verbunden als {{handle}}",
      "successWhatsapp": "WhatsApp verbunden",
      "webhookPending": "Instagram ist verbunden, aber die Nachrichtenübermittlung wartet auf Überprüfung."
    },
    "errors": {
      "accessDenied": "Sie haben die Berechtigungen abgebrochen. Versuchen Sie es erneut, wenn Sie bereit sind.",
      "connectFailed": "Verbindung fehlgeschlagen. Bitte erneut versuchen."
    },
    "email": {
      "connect": "E-Mail verbinden",
      "connectTooltip": "Gemeinsames Postfach für Kunden-E-Mails in Chats verbinden (alle Studios)",
      "wizard": {
        "title": "E-Mail verbinden",
        "introBody": "Verbinden Sie Ihr Studio-Postfach, damit OktoGo Kunden-E-Mail-Threads in Chats verwalten kann.",
        "providerGoogle": "Google (Gmail / Google Workspace)",
        "providerMicrosoft": "Microsoft (Outlook / Microsoft 365)",
        "prereqsTitle": "Vor der Verbindung",
        "prereqsBody": "Verwenden Sie ein Konto, mit dem Sie sich bei Google oder Microsoft anmelden können. Sie benötigen die Berechtigung, dieses Postfach für Ihr Unternehmen zu verbinden.",
        "confirm": "E-Mail verbinden",
        "defaultStudioLabel": "Standardstudio für neue E-Mail-Threads",
        "defaultStudioHint": "Neue eingehende E-Mails werden diesem Studio zugeordnet, bis der Kunde etwas anderes angibt.",
        "openChats": "Chats öffnen"
      },
      "oauth": {
        "success": "E-Mail verbunden",
        "successAddress": "Verbunden als {{address}}"
      }
    }
  },
  "whatsappSignup": {
    "title": "WhatsApp Business verbinden",
    "description": "Autorisieren Sie OktoGo, Nachrichten im Namen Ihres WhatsApp-Business-Kontos zu verwalten.",
    "connectButton": "Mit Meta verbinden",
    "fbFlow": "Schließen Sie die Anmeldung im Meta-Fenster ab…",
    "saving": "Verbindung wird gespeichert…",
    "successRedirect": "WhatsApp verbunden! Weiterleitung…",
    "hint": "Sie melden sich bei Meta an und wählen Ihr WhatsApp-Business-Konto.",
    "metaCompleteHint": "Die Meta-Autorisierung ist abgeschlossen. Geben Sie unten Ihre PIN ein, um die Verbindung in OktoGo abzuschließen.",
    "pinDescription": "Geben Sie die 6-stellige PIN der WhatsApp-Zwei-Schritt-Verifizierung ein, um diese Nummer bei der Meta Cloud API zu registrieren.",
    "pinLabel": "WhatsApp-PIN",
    "pinPlaceholder": "6-stellige PIN",
    "pinSubmit": "Aktivieren und verbinden",
    "retry": "Erneut versuchen",
    "errors": {
      "generic": "Etwas ist schiefgelaufen.",
      "missingConfig": "Meta-App-Konfiguration fehlt. Prüfen Sie VITE_META_APP_ID und VITE_META_ES_CONFIG_ID.",
      "phoneAlreadyConnected": "Diese Telefonnummer ist bereits mit einem anderen Studio in Ihrem Konto verbunden.",
      "metaExchangeFailed": "Meta konnte den Anmeldecode nicht austauschen. Prüfen Sie die Server-Redirect-URI.",
      "wabaDiscoveryFailed": "WhatsApp-Business-Konto nicht gefunden. Stellen Sie sicher, dass ein WABA mit Telefonnummer existiert.",
      "studioContextRequired": "Wählen Sie ein bestimmtes Studio aus, bevor Sie WhatsApp verbinden, und versuchen Sie es erneut über Einstellungen oder Chats.",
      "connectFailed": "WhatsApp-Verbindung konnte nicht gespeichert werden. Bitte erneut versuchen.",
      "sessionExpired": "Ihre Sitzung ist abgelaufen. Melden Sie sich erneut an und verbinden Sie WhatsApp über die Einstellungen.",
      "network": "Netzwerkfehler beim Speichern. Bitte erneut versuchen.",
      "cancelled": "Meta-Anmeldung abgebrochen. Bitte erneut versuchen.",
      "sdkLoadFailed": "Meta-Anmelde-SDK konnte nicht geladen werden. Seite neu laden und erneut versuchen.",
      "activationRequired": "Geben Sie Ihre 6-stellige WhatsApp-PIN ein, um Nachrichten zu aktivieren.",
      "pinInvalid": "PIN stimmt nicht mit der WhatsApp-Zwei-Schritt-Verifizierung überein.",
      "reverificationRequired": "WhatsApp erfordert eine erneute Telefonverifizierung in Meta Business.",
      "registerRateLimited": "Zu viele Registrierungsversuche. Versuchen Sie es in bis zu 72 Stunden erneut.",
      "registerFailed": "WhatsApp-Telefonregistrierung fehlgeschlagen. Bitte erneut versuchen."
    }
  },
  "whatsappTemplates": {
    "title": "Nachrichtenvorlagen",
    "subtitle": "Genehmigte Vorlagen Ihres verbundenen WhatsApp-Business-Kontos (für Nachrichten außerhalb des 24-Stunden-Fensters).",
    "loading": "Vorlagen werden geladen…",
    "empty": "Keine Nachrichtenvorlagen für dieses Konto gefunden.",
    "errorLoad": "Nachrichtenvorlagen konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "colName": "Name",
    "colLanguage": "Sprache",
    "colCategory": "Kategorie",
    "colStatus": "Status"
  },
  "whatsappSetup": {
    "title": "Verbundenes WhatsApp-Konto",
    "subtitle": "Live-Details zu WABA, Telefonnummer, Verifizierung und Webhook-Abonnement.",
    "loading": "Kontodetails werden geladen…",
    "errorLoad": "WhatsApp-Kontodetails konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "wabaId": "WABA-ID",
    "phoneNumber": "Telefonnummer",
    "displayName": "Anzeigename",
    "phoneVerification": "Telefonverifizierung",
    "nameVerification": "Anzeigenamen-Verifizierung",
    "webhookSubscription": "Webhook-Abonnement",
    "webhookSubscribed": "Abonniert",
    "webhookNotSubscribed": "Nicht abonniert",
    "webhookAppId": "Meta-App-ID",
    "webhookFields": "Abonnierte Felder"
  },
  "onboarding": {
    "shell": {
      "stepOf": "Schritt {{current}} von {{total}}",
      "exitAria": "Einrichtung verlassen",
      "exitTitle": "Fortschritt speichern und später weitermachen?",
      "exitDescription": "Ihr Fortschritt wird gespeichert. Sie können die Einrichtung beim nächsten Login fortsetzen.",
      "cancel": "Abbrechen",
      "saveAndExit": "Speichern und verlassen"
    },
    "instagram": {
      "title": "Instagram verbinden",
      "description": "Verbinden Sie Ihr Instagram-Business-Konto, damit OktoGo Kundennachrichten verwalten kann.",
      "errorConnect": "Instagram-Verbindung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "connected": "Verbunden",
      "connectButton": "Instagram verbinden",
      "retry": "Erneut versuchen",
      "continue": "Weiter",
      "skipLater": "Später erledigen",
      "testErrorEnable": "(Test: Fehlermodus aktivieren)",
      "testErrorDisable": "(Test: Fehlermodus deaktivieren)"
    },
    "whatsapp": {
      "title": "WhatsApp Business verbinden",
      "description": "Verbinden Sie Ihr WhatsApp-Business-Konto, damit OktoGo Kundennachrichten verwalten kann.",
      "errorConnect": "WhatsApp-Verbindung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "connected": "Verbunden",
      "connectButton": "WhatsApp verbinden",
      "retry": "Erneut versuchen",
      "continue": "Weiter",
      "skipLater": "Später erledigen",
      "back": "Zurück"
    },
    "booking": {
      "title": "Buchungsplattform verbinden",
      "description": "Verbinden Sie Ihre Buchungsplattform, um Kurse, Termine und Mitgliedschaften zu synchronisieren.",
      "errorCredentials": "Ungültige Anmeldedaten oder Plattform nicht verfügbar. Bitte erneut versuchen.",
      "connected": "Verbunden",
      "continue": "Weiter",
      "platformLabel": "Buchungsplattform",
      "usernameLabel": "Benutzername / E-Mail",
      "passwordLabel": "Passwort",
      "skipLater": "Später erledigen",
      "disclosure": "Wir speichern Ihre Zugangsdaten sicher, um Buchungen und Termine zu synchronisieren. Ihr Passwort ist verschlüsselt und nur für die sicheren Server von OktoGo zugänglich.",
      "testConnection": "Verbindung testen",
      "back": "Zurück",
      "testErrorEnable": "(Test: Fehlermodus aktivieren)",
      "testErrorDisable": "(Test: Fehlermodus deaktivieren)",
      "manualCodeLabel": "Zusätzlicher Anmeldecode",
      "manualCodeHint": "Eversports hat einen Einmalcode gesendet (SMS, E-Mail oder Authenticator). Bitte eingeben und erneut testen.",
      "manualCodeRequiredTitle": "Manuelle Bestätigung erforderlich"
    },
    "twoFa": {
      "title": "2FA-Zugangsdaten einrichten",
      "description": "Eversports erfordert 2FA. Geben Sie Ihre Zugangsdaten an, damit OktoGo sich in Ihrem Namen authentifizieren kann.",
      "errorVerify": "2FA-Prüfung fehlgeschlagen – prüfen Sie Ihre Zugangsdaten und versuchen Sie es erneut.",
      "verified": "2FA bestätigt",
      "verifiedHint": "Eversports-Authentifizierung bereit",
      "continue": "Weiter",
      "methodLabel": "2FA-Methode",
      "methodAuthenticator": "Authenticator-App",
      "methodSms": "SMS",
      "methodBackup": "Backup-Code",
      "secretLabel": "2FA-Geheimnis / Backup-Code",
      "disclosure": "Ihre 2FA-Zugangsdaten sind verschlüsselt und werden nur gespeichert, damit OktoGo sich bei Eversports in Ihrem Namen anmelden kann. Sie werden nicht weitergegeben.",
      "skipLater": "Später erledigen",
      "back": "Zurück",
      "testButton": "2FA testen",
      "syncLimitedHint": "Die Synchronisation kann eingeschränkt sein, bis 2FA hinterlegt ist",
      "testErrorEnable": "(Test: Fehlermodus aktivieren)",
      "testErrorDisable": "(Test: Fehlermodus deaktivieren)"
    },
    "email": {
      "title": "E-Mail verbinden",
      "description": "Verbinden Sie Ihr Studio-Postfach, damit OktoGo Kunden-E-Mail-Threads in Chats verwalten kann.",
      "connectButton": "E-Mail verbinden",
      "skipLater": "Später erledigen",
      "back": "Zurück",
      "continue": "Weiter",
      "connected": "E-Mail verbunden",
      "connectedHint": "Ihr Postfach ist bereit für Kunden-E-Mails in Chats.",
      "optionalHint": "Optional — Sie können E-Mail später unter Einstellungen verbinden."
    },
    "messaging": {
      "title": "Messaging-Kanäle verbinden",
      "description": "Verbinden Sie Instagram und WhatsApp, damit OktoGo Kundennachrichten in Chats verwalten kann.",
      "continue": "Weiter",
      "skipLater": "Später erledigen",
      "back": "Zurück",
      "optionalHint": "Optional — Sie können diese später unter Einstellungen → Kanäle verbinden."
    },
    "oauthCallbackLoading": "Konto wird verbunden…",
    "errors": {
      "connectFailed": "Verbindung fehlgeschlagen. Bitte versuchen Sie es erneut."
    },
    "sync": {
      "titleRunning": "Studio-Daten werden synchronisiert …",
      "titleDone": "Synchronisation abgeschlossen!",
      "titleSkipped": "Fürs Erste ist alles bereit",
      "hintRunning": "Das dauert nur einen Moment.",
      "hintDone": "Ihre Studio-Daten wurden erfolgreich importiert.",
      "hintSkipped": "Noch keine Buchungsplattform verbunden. Sie können sie später unter Einstellungen → Verbindungen anbinden.",
      "stageClasses": "Kurse werden geladen",
      "stageSchedule": "Termine werden synchronisiert",
      "stageMemberships": "Mitgliedschaften werden importiert",
      "stagePolicies": "Richtlinien werden geladen",
      "continueDashboard": "Weiter zum Dashboard",
      "completing": "Wird abgeschlossen …",
      "summaryDemo": "{{classes}} Kurse, {{sessions}} kommende Termine, {{tiers}} Mitgliedschaftsstufen importiert.",
      "summaryReal": "{{classes}} Kurse und {{policies}} Richtlinien erfolgreich importiert.",
      "summaryGeneric": "Studio-Daten erfolgreich importiert.",
      "summaryNoData": "Einrichtung abgeschlossen. Sie können später in Einstellungen → Verbindungen eine Buchungsplattform anbinden.",
      "confirmTitle": "Öffentliche Eversports-Links bestätigen",
      "confirmLinks": "Prüfen Sie Overview-, Classes- und Prices-URLs unter Studio Data → Allgemein.",
      "confirmClassPrices": "Klassenbeschreibungen und Pricing options werden von Eversports synchronisiert, sobald verfügbar — prüfen Sie sie unter Studio Data → Kurse.",
      "confirmHonesty": "Live-Preise von Eversports haben Vorrang. Solange Klassenpreise fehlen, kann Copilot den Prices-Seitenlink senden — wir erfinden keine Euro-Beträge.",
      "ctaReviewLinks": "Abschnittslinks in Studio Data prüfen",
      "ctaReviewClasses": "Kurse & Preise in Studio Data prüfen",
      "titleError": "Synchronisation fehlgeschlagen",
      "hintError": "Wir konnten Ihre Studio-Daten gerade nicht importieren.",
      "errorBody": "Beim Import Ihrer Daten ist ein Fehler aufgetreten. Sie können jetzt erneut versuchen oder die Einrichtung abschließen und es später in den Einstellungen wiederholen.",
      "retry": "Erneut synchronisieren",
      "back": "Zurück"
    }
  },
  "management": {
    "title": "Pilot-Verwaltung",
    "subtitle": "Pilot-Kunden per Einladung steuern und onboarden.",
    "signOut": "Abmelden",
    "login": {
      "title": "Management-Zugang",
      "subtitle": "Mit einem Plattform-Admin-Konto anmelden.",
      "emailLabel": "E-Mail",
      "emailPlaceholder": "admin@oktogo.ai",
      "passwordLabel": "Passwort",
      "passwordPlaceholder": "Passwort eingeben",
      "signIn": "Anmelden",
      "signingIn": "Anmeldung..."
    },
    "accept": {
      "title": "Pilot-Einladung annehmen",
      "subtitle": "Erstellen Sie ein sicheres Passwort, um mit dem Onboarding zu starten.",
      "email": "E-Mail",
      "studio": "Studio",
      "expiresAt": "Läuft ab am",
      "password": "Passwort",
      "passwordPlaceholder": "Passwort erstellen",
      "terms": "Ich akzeptiere die Pilot-Onboarding-Bedingungen",
      "submit": "Einladung annehmen",
      "accepting": "Einladung wird angenommen..."
    },
    "createInvite": {
      "title": "Pilot-Einladung erstellen",
      "email": "E-Mail des Inhabers",
      "fullName": "Vollständiger Name (optional)",
      "studioName": "Studio-Name",
      "planId": "Plan-ID",
      "submit": "Einladung erstellen und senden",
      "creating": "Einladung wird erstellt..."
    },
    "invites": {
      "title": "Pilot-Einladungen",
      "loading": "Einladungen werden geladen...",
      "empty": "Keine Einladungen für den ausgewählten Filter.",
      "filterAria": "Einladungen nach Status filtern",
      "filterAll": "Alle Status",
      "columns": {
        "email": "E-Mail",
        "studio": "Studio",
        "status": "Status",
        "expiresAt": "Läuft ab am",
        "actions": "Aktionen"
      },
      "actions": {
        "resend": "Erneut senden",
        "revoke": "Widerrufen"
      }
    },
    "status": {
      "pending": "Ausstehend",
      "sent": "Gesendet",
      "accepted": "Angenommen",
      "expired": "Abgelaufen",
      "revoked": "Widerrufen"
    },
    "vertical": {
      "fitness": "Fitness",
      "shortTermRental": "Kurzzeitvermietung"
    },
    "messages": {
      "inviteCreated": "Pilot-Einladung erstellt ({{id}}).",
      "inviteActionSuccess": "Einladung aktualisiert.",
      "inviteAccepted": "Einladung angenommen. Ihr Konto ist jetzt aktiv."
    },
    "errors": {
      "login": "Anmeldung nicht möglich.",
      "platformAdminRequired": "Plattform-Admin-Zugriff ist erforderlich.",
      "loadInvites": "Einladungen konnten nicht geladen werden.",
      "createInvite": "Einladung konnte nicht erstellt werden.",
      "inviteAction": "Einladung konnte nicht aktualisiert werden.",
      "invalidInviteToken": "Einladungs-Token fehlt.",
      "loadInviteToken": "Dieses Einladungs-Token konnte nicht geprüft werden.",
      "acceptInvite": "Einladung konnte nicht angenommen werden."
    }
  },
  "compliance": {
    "aiDisclosure": {
      "auto": {
        "plain": "Hallo! Hier schreibt der KI-Assistent dieses Studios. Ich helfe bei Kursplan, Buchungen und kurzen Fragen - ein Teammitglied kann jederzeit übernehmen.",
        "named": "Hallo {{channelFirstName}}. Hier schreibt der KI-Assistent dieses Studios. Ich helfe bei Kursplan, Buchungen und kurzen Fragen - ein Teammitglied kann jederzeit übernehmen."
      },
      "manual": {
        "plain": "Hallo! Hier schreibt der KI-Assistent dieses Studios. Diese Antwort habe ich vorbereitet, ein Teammitglied hat sie vor dem Senden geprüft - ein Mensch ist jederzeit erreichbar.",
        "named": "Hallo {{channelFirstName}}. Hier schreibt der KI-Assistent dieses Studios. Diese Antwort habe ich vorbereitet, ein Teammitglied hat sie vor dem Senden geprüft - ein Mensch ist jederzeit erreichbar."
      }
    }
  }
}
